// survey-core v3 removed four legacy theme families that shipped in v2: Sharp,
// DoubleBorder, Layered, and Solid. Without them, an existing survey stored on one
// of these families no longer matches a registered theme: opening the Theme tab in
// SurveyForm silently rewrites its themeName to 'default' and drops the family's
// base styling on the next autosave.
//
// These 16 objects (4 removed families x light/dark x panelled/panelless) restore
// that registration. They are the verbatim theme definitions from
// survey-core@2.5.36's 'survey-core/themes' export, with cssVariables run through
// v3's own survey-core::patchLegacyCSSVariables() — the same compatibility shim v3
// already applies to a survey's per-instance override variables — so they carry the
// same '--sjs2-*' namespace as every other registered v3 theme. That shim is a
// best-effort mapping (covers roughly 60% of the legacy variable surface, skipping
// print/PDF-export typography and a few color aliases); the untranslated
// '--sjs-*' variables are left in place alongside the translated ones, matching how
// survey-core itself leaves them for a live survey's override cssVariables.
//
// Regenerate, if ever needed: fetch survey-core@2.5.36's themes/index.js (its
// UMD build `require()`s cleanly under Node) for the raw Sharp/DoubleBorder/
// Layered/Solid x Light/Dark/LightPanelless/DarkPanelless objects, then run each
// theme's cssVariables through the currently installed survey-core's exported
// patchLegacyCSSVariables(cssVariables, isPanelless) before re-serializing.

export const SharpLight = {
  "themeName": "sharp",
  "colorPalette": "light",
  "cssVariables": {
    "--sjs-general-dim-forecolor": "rgba(0, 0, 0, 0.91)",
    "--sjs-general-dim-forecolor-light": "rgba(0, 0, 0, 0.6)",
    "--sjs-secondary-backcolor": "rgba(255, 152, 20, 1)",
    "--sjs-secondary-backcolor-light": "rgba(255, 152, 20, 0.1)",
    "--sjs-secondary-backcolor-semi-light": "rgba(255, 152, 20, 0.25)",
    "--sjs-secondary-forecolor": "rgba(255, 255, 255, 1)",
    "--sjs-secondary-forecolor-light": "rgba(255, 255, 255, 0.25)",
    "--sjs-shadow-small-reset": "0px 0px 0px 0px rgba(0, 0, 0, 0.2)",
    "--sjs-shadow-inner-reset": "0px 0px 0px 0px rgba(0, 0, 0, 0.25)",
    "--sjs-article-font-xx-large-textDecoration": "none",
    "--sjs-article-font-xx-large-fontWeight": "700",
    "--sjs-article-font-xx-large-fontStyle": "normal",
    "--sjs-article-font-xx-large-fontStretch": "normal",
    "--sjs-article-font-xx-large-letterSpacing": "0",
    "--sjs-article-font-xx-large-lineHeight": "64px",
    "--sjs-article-font-xx-large-paragraphIndent": "0px",
    "--sjs-article-font-xx-large-textCase": "none",
    "--sjs-article-font-x-large-textDecoration": "none",
    "--sjs-article-font-x-large-fontWeight": "700",
    "--sjs-article-font-x-large-fontStyle": "normal",
    "--sjs-article-font-x-large-fontStretch": "normal",
    "--sjs-article-font-x-large-letterSpacing": "0",
    "--sjs-article-font-x-large-lineHeight": "56px",
    "--sjs-article-font-x-large-paragraphIndent": "0px",
    "--sjs-article-font-x-large-textCase": "none",
    "--sjs-article-font-large-textDecoration": "none",
    "--sjs-article-font-large-fontWeight": "700",
    "--sjs-article-font-large-fontStyle": "normal",
    "--sjs-article-font-large-fontStretch": "normal",
    "--sjs-article-font-large-letterSpacing": "0",
    "--sjs-article-font-large-lineHeight": "40px",
    "--sjs-article-font-large-paragraphIndent": "0px",
    "--sjs-article-font-large-textCase": "none",
    "--sjs-article-font-medium-textDecoration": "none",
    "--sjs-article-font-medium-fontWeight": "700",
    "--sjs-article-font-medium-fontStyle": "normal",
    "--sjs-article-font-medium-fontStretch": "normal",
    "--sjs-article-font-medium-letterSpacing": "0",
    "--sjs-article-font-medium-lineHeight": "32px",
    "--sjs-article-font-medium-paragraphIndent": "0px",
    "--sjs-article-font-medium-textCase": "none",
    "--sjs-article-font-default-textDecoration": "none",
    "--sjs-article-font-default-fontWeight": "400",
    "--sjs-article-font-default-fontStyle": "normal",
    "--sjs-article-font-default-fontStretch": "normal",
    "--sjs-article-font-default-letterSpacing": "0",
    "--sjs-article-font-default-lineHeight": "28px",
    "--sjs-article-font-default-paragraphIndent": "0px",
    "--sjs-article-font-default-textCase": "none",
    "--sjs2-color-component-action-brand-tertiary-surface-default-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-brand-tertiary-surface-hovered-bg": "rgba(228, 228, 228, 1)",
    "--sjs2-color-bg-basic-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-utility-property-grid": "rgba(255, 255, 255, 1)",
    "--sjs2-color-utility-tabs": "rgba(255, 255, 255, 1)",
    "--sjs2-color-utility-toolbox": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-default-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-hovered-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-default-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-hovered-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-default-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-hovered-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-basic-primary-dim": "rgba(228, 228, 228, 1)",
    "--sjs2-color-bg-neutral-tertiary-dim": "rgba(224, 224, 224, 1)",
    "--sjs2-color-utility-sheet": "rgba(224, 224, 224, 1)",
    "--sjs2-color-utility-surface-survey": "rgba(224, 224, 224, 1)",
    "--sjs2-color-bg-basic-secondary": "rgba(238, 238, 238, 1)",
    "--sjs2-color-bg-basic-secondary-dim": "rgba(220, 220, 220, 1)",
    "--sjs2-color-fg-basic-primary": "rgba(0, 0, 0, 0.91)",
    "--sjs2-color-fg-basic-secondary": "rgba(0, 0, 0, 0.6)",
    "--sjs2-color-component-action-alert-quaternary-surface-default-icon": "rgba(0, 0, 0, 0.6)",
    "--sjs2-color-component-action-brand-quaternary-surface-default-icon": "rgba(0, 0, 0, 0.6)",
    "--sjs2-color-component-action-neutral-quaternary-surface-default-icon": "rgba(0, 0, 0, 0.6)",
    "--sjs2-color-project-brand-600": "rgba(103, 58, 176, 1)",
    "--sjs2-color-component-tagbox-item-default-bg": "rgba(103, 58, 176, 1)",
    "--sjs2-color-component-tagbox-item-hovered-bg": "rgba(103, 58, 176, 1)",
    "--sjs2-color-bg-brand-secondary": "rgba(103, 58, 176, 0.1)",
    "--sjs2-color-bg-brand-primary-dim": "rgba(69, 24, 142, 1)",
    "--sjs2-color-fg-brand-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-default-label": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-hovered-label": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-action-hovered-icon": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-action-pressed-icon": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-action-default-icon": "rgba(255, 255, 255, 1)",
    "--sjs2-color-fg-brand-primary-disabled": "rgba(255, 255, 255, 0.25)",
    "--sjs2-color-component-tagbox-item-action-hovered-bg": "rgba(255, 255, 255, 0.25)",
    "--sjs2-base-unit-size": "8px",
    "--sjs2-base-unit-spacing": "8px",
    "--sjs2-base-unit-radius": "4px",
    "--sjs2-border-effect-surface-default": "0px 0px 0px 1px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-panel-default": "0px 0px 0px 1px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-default": "0px 0px 0px 1px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-hovered": "0px 0px 0px 1px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-disabled": "0px 0px 0px 1px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-primary-default": "0px 0px 0px 1px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-primary-hovered": "0px 0px 0px 1px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-primary-disabled": "0px 0px 0px 1px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-floating-default": "0px 2px 6px 0px rgba(0, 0, 0, 0.1),0px 8px 16px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-formbox-default": "0px 0px 0px 1px rgba(0, 0, 0, 0.25)",
    "--sjs2-border-effect-component-formbox-hovered": "0px 0px 0px 1px rgba(0, 0, 0, 0.25)",
    "--sjs2-border-effect-component-checkbox-true-default": "0px 0px 0px 1px rgba(0, 0, 0, 0.25)",
    "--sjs2-border-effect-component-checkbox-false-default": "0px 0px 0px 1px rgba(0, 0, 0, 0.25)",
    "--sjs2-border-effect-component-radio-true-default": "0px 0px 0px 1px rgba(0, 0, 0, 0.25)",
    "--sjs2-border-effect-component-radio-false-default": "0px 0px 0px 1px rgba(0, 0, 0, 0.25)",
    "--sjs2-color-border-basic-secondary": "rgba(0, 0, 0, 0.25)",
    "--sjs2-color-component-input-default-line": "rgba(0, 0, 0, 0.25)",
    "--sjs2-color-border-basic-secondary-overlay": "rgba(0, 0, 0, 0.16)",
    "--sjs2-color-bg-alert-primary": "rgba(229, 10, 62, 1)",
    "--sjs2-color-bg-alert-secondary": "rgba(229, 10, 62, 0.1)",
    "--sjs2-color-fg-alert-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-positive-primary": "rgba(25, 179, 148, 1)",
    "--sjs2-color-bg-positive-secondary": "rgba(25, 179, 148, 0.1)",
    "--sjs2-color-fg-positive-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-note-primary": "rgba(67, 127, 217, 1)",
    "--sjs2-color-bg-note-secondary": "rgba(67, 127, 217, 0.1)",
    "--sjs2-color-fg-note-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-warning-primary": "rgba(255, 152, 20, 1)",
    "--sjs2-color-bg-warning-secondary": "rgba(255, 152, 20, 0.1)",
    "--sjs2-color-fg-warning-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-radius-component-panel": "4px",
    "--sjs2-radius-component-formbox": "4px",
    "--sjs2-radius-component-action": "4px"
  }
};

export const SharpDark = {
  "themeName": "sharp",
  "colorPalette": "dark",
  "cssVariables": {
    "--sjs-general-dim-forecolor": "rgba(255, 255, 255, 0.8)",
    "--sjs-general-dim-forecolor-light": "rgba(255, 255, 255, 0.55)",
    "--sjs-secondary-backcolor": "rgba(255, 152, 20, 1)",
    "--sjs-secondary-backcolor-light": "rgba(255, 152, 20, 0.1)",
    "--sjs-secondary-backcolor-semi-light": "rgba(255, 152, 20, 0.25)",
    "--sjs-secondary-forecolor": "rgba(48, 48, 48, 1)",
    "--sjs-secondary-forecolor-light": "rgba(48, 48, 48, 0.25)",
    "--sjs-shadow-small-reset": "0px 0px 0px 0px rgba(255, 255, 255, 0.28)",
    "--sjs-shadow-inner-reset": "0px 0px 0px 0px rgba(255, 255, 255, 0.22)",
    "--sjs-article-font-xx-large-textDecoration": "none",
    "--sjs-article-font-xx-large-fontWeight": "700",
    "--sjs-article-font-xx-large-fontStyle": "normal",
    "--sjs-article-font-xx-large-fontStretch": "normal",
    "--sjs-article-font-xx-large-letterSpacing": "0",
    "--sjs-article-font-xx-large-lineHeight": "64px",
    "--sjs-article-font-xx-large-paragraphIndent": "0px",
    "--sjs-article-font-xx-large-textCase": "none",
    "--sjs-article-font-x-large-textDecoration": "none",
    "--sjs-article-font-x-large-fontWeight": "700",
    "--sjs-article-font-x-large-fontStyle": "normal",
    "--sjs-article-font-x-large-fontStretch": "normal",
    "--sjs-article-font-x-large-letterSpacing": "0",
    "--sjs-article-font-x-large-lineHeight": "56px",
    "--sjs-article-font-x-large-paragraphIndent": "0px",
    "--sjs-article-font-x-large-textCase": "none",
    "--sjs-article-font-large-textDecoration": "none",
    "--sjs-article-font-large-fontWeight": "700",
    "--sjs-article-font-large-fontStyle": "normal",
    "--sjs-article-font-large-fontStretch": "normal",
    "--sjs-article-font-large-letterSpacing": "0",
    "--sjs-article-font-large-lineHeight": "40px",
    "--sjs-article-font-large-paragraphIndent": "0px",
    "--sjs-article-font-large-textCase": "none",
    "--sjs-article-font-medium-textDecoration": "none",
    "--sjs-article-font-medium-fontWeight": "700",
    "--sjs-article-font-medium-fontStyle": "normal",
    "--sjs-article-font-medium-fontStretch": "normal",
    "--sjs-article-font-medium-letterSpacing": "0",
    "--sjs-article-font-medium-lineHeight": "32px",
    "--sjs-article-font-medium-paragraphIndent": "0px",
    "--sjs-article-font-medium-textCase": "none",
    "--sjs-article-font-default-textDecoration": "none",
    "--sjs-article-font-default-fontWeight": "400",
    "--sjs-article-font-default-fontStyle": "normal",
    "--sjs-article-font-default-fontStretch": "normal",
    "--sjs-article-font-default-letterSpacing": "0",
    "--sjs-article-font-default-lineHeight": "28px",
    "--sjs-article-font-default-paragraphIndent": "0px",
    "--sjs-article-font-default-textCase": "none",
    "--sjs2-color-component-action-brand-tertiary-surface-default-bg": "rgba(48, 48, 48, 1)",
    "--sjs2-color-component-action-brand-tertiary-surface-hovered-bg": "rgba(58, 58, 58, 1)",
    "--sjs2-color-bg-basic-primary": "rgba(48, 48, 48, 1)",
    "--sjs2-color-utility-property-grid": "rgba(48, 48, 48, 1)",
    "--sjs2-color-utility-tabs": "rgba(48, 48, 48, 1)",
    "--sjs2-color-utility-toolbox": "rgba(48, 48, 48, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-default-bg": "rgba(48, 48, 48, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-hovered-bg": "rgba(48, 48, 48, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-default-bg": "rgba(48, 48, 48, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-hovered-bg": "rgba(48, 48, 48, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-default-bg": "rgba(48, 48, 48, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-hovered-bg": "rgba(48, 48, 48, 1)",
    "--sjs2-color-bg-basic-primary-dim": "rgba(58, 58, 58, 1)",
    "--sjs2-color-bg-neutral-tertiary-dim": "rgba(27, 27, 27, 1)",
    "--sjs2-color-utility-sheet": "rgba(27, 27, 27, 1)",
    "--sjs2-color-utility-surface-survey": "rgba(27, 27, 27, 1)",
    "--sjs2-color-bg-basic-secondary": "rgba(33, 33, 33, 1)",
    "--sjs2-color-bg-basic-secondary-dim": "rgba(47, 47, 47, 1)",
    "--sjs2-color-fg-basic-primary": "rgba(255, 255, 255, 0.78)",
    "--sjs2-color-fg-basic-secondary": "rgba(255, 255, 255, 0.5)",
    "--sjs2-color-component-action-alert-quaternary-surface-default-icon": "rgba(255, 255, 255, 0.5)",
    "--sjs2-color-component-action-brand-quaternary-surface-default-icon": "rgba(255, 255, 255, 0.5)",
    "--sjs2-color-component-action-neutral-quaternary-surface-default-icon": "rgba(255, 255, 255, 0.5)",
    "--sjs2-color-project-brand-600": "rgba(16, 226, 255, 1)",
    "--sjs2-color-component-tagbox-item-default-bg": "rgba(16, 226, 255, 1)",
    "--sjs2-color-component-tagbox-item-hovered-bg": "rgba(16, 226, 255, 1)",
    "--sjs2-color-bg-brand-secondary": "rgba(0, 0, 0, 0.35)",
    "--sjs2-color-bg-brand-primary-dim": "rgba(129, 240, 255, 1)",
    "--sjs2-color-fg-brand-on-primary": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-default-label": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-hovered-label": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-action-hovered-icon": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-action-pressed-icon": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-action-default-icon": "rgba(32, 32, 32, 1)",
    "--sjs2-color-fg-brand-primary-disabled": "rgba(32, 32, 32, 0.25)",
    "--sjs2-color-component-tagbox-item-action-hovered-bg": "rgba(32, 32, 32, 0.25)",
    "--sjs2-base-unit-size": "8px",
    "--sjs2-base-unit-spacing": "8px",
    "--sjs2-base-unit-radius": "4px",
    "--sjs2-border-effect-surface-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.28)",
    "--sjs2-border-effect-component-panel-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.28)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.28)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-hovered": "0px 0px 0px 1px rgba(255, 255, 255, 0.28)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-disabled": "0px 0px 0px 1px rgba(255, 255, 255, 0.28)",
    "--sjs2-border-effect-component-action-brand-primary-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.28)",
    "--sjs2-border-effect-component-action-brand-primary-hovered": "0px 0px 0px 1px rgba(255, 255, 255, 0.28)",
    "--sjs2-border-effect-component-action-brand-primary-disabled": "0px 0px 0px 1px rgba(255, 255, 255, 0.28)",
    "--sjs2-border-effect-floating-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.25),0px 2px 6px 0px rgba(0, 0, 0, 0.2),0px 8px 16px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-formbox-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.22)",
    "--sjs2-border-effect-component-formbox-hovered": "0px 0px 0px 1px rgba(255, 255, 255, 0.22)",
    "--sjs2-border-effect-component-checkbox-true-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.22)",
    "--sjs2-border-effect-component-checkbox-false-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.22)",
    "--sjs2-border-effect-component-radio-true-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.22)",
    "--sjs2-border-effect-component-radio-false-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.22)",
    "--sjs2-color-border-basic-secondary": "rgba(255, 255, 255, 0.22)",
    "--sjs2-color-component-input-default-line": "rgba(255, 255, 255, 0.22)",
    "--sjs2-color-border-basic-secondary-overlay": "rgba(255, 255, 255, 0.08)",
    "--sjs2-color-bg-alert-primary": "rgba(254, 76, 108, 1)",
    "--sjs2-color-bg-alert-secondary": "rgba(254, 76, 108, 0.1)",
    "--sjs2-color-fg-alert-on-primary": "rgba(48, 48, 48, 1)",
    "--sjs2-color-bg-positive-primary": "rgba(36, 197, 164, 1)",
    "--sjs2-color-bg-positive-secondary": "rgba(36, 197, 164, 0.1)",
    "--sjs2-color-fg-positive-on-primary": "rgba(48, 48, 48, 1)",
    "--sjs2-color-bg-note-primary": "rgba(91, 151, 242, 1)",
    "--sjs2-color-bg-note-secondary": "rgba(91, 151, 242, 0.1)",
    "--sjs2-color-fg-note-on-primary": "rgba(48, 48, 48, 1)",
    "--sjs2-color-bg-warning-primary": "rgba(255, 152, 20, 1)",
    "--sjs2-color-bg-warning-secondary": "rgba(255, 152, 20, 0.1)",
    "--sjs2-color-fg-warning-on-primary": "rgba(48, 48, 48, 1)",
    "--sjs2-radius-component-panel": "4px",
    "--sjs2-radius-component-formbox": "4px",
    "--sjs2-radius-component-action": "4px"
  }
};

export const SharpLightPanelless = {
  "themeName": "sharp",
  "colorPalette": "light",
  "isPanelless": true,
  "cssVariables": {
    "--sjs-general-dim-forecolor": "rgba(0, 0, 0, 0.91)",
    "--sjs-general-dim-forecolor-light": "rgba(0, 0, 0, 0.6)",
    "--sjs-secondary-backcolor": "rgba(255, 152, 20, 1)",
    "--sjs-secondary-backcolor-light": "rgba(255, 152, 20, 0.1)",
    "--sjs-secondary-backcolor-semi-light": "rgba(255, 152, 20, 0.25)",
    "--sjs-secondary-forecolor": "rgba(255, 255, 255, 1)",
    "--sjs-secondary-forecolor-light": "rgba(255, 255, 255, 0.25)",
    "--sjs-shadow-small-reset": "0px 0px 0px 0px rgba(0, 0, 0, 0.2)",
    "--sjs-shadow-inner-reset": "0px 0px 0px 0px rgba(0, 0, 0, 0.25)",
    "--sjs-article-font-xx-large-textDecoration": "none",
    "--sjs-article-font-xx-large-fontWeight": "700",
    "--sjs-article-font-xx-large-fontStyle": "normal",
    "--sjs-article-font-xx-large-fontStretch": "normal",
    "--sjs-article-font-xx-large-letterSpacing": "0",
    "--sjs-article-font-xx-large-lineHeight": "64px",
    "--sjs-article-font-xx-large-paragraphIndent": "0px",
    "--sjs-article-font-xx-large-textCase": "none",
    "--sjs-article-font-x-large-textDecoration": "none",
    "--sjs-article-font-x-large-fontWeight": "700",
    "--sjs-article-font-x-large-fontStyle": "normal",
    "--sjs-article-font-x-large-fontStretch": "normal",
    "--sjs-article-font-x-large-letterSpacing": "0",
    "--sjs-article-font-x-large-lineHeight": "56px",
    "--sjs-article-font-x-large-paragraphIndent": "0px",
    "--sjs-article-font-x-large-textCase": "none",
    "--sjs-article-font-large-textDecoration": "none",
    "--sjs-article-font-large-fontWeight": "700",
    "--sjs-article-font-large-fontStyle": "normal",
    "--sjs-article-font-large-fontStretch": "normal",
    "--sjs-article-font-large-letterSpacing": "0",
    "--sjs-article-font-large-lineHeight": "40px",
    "--sjs-article-font-large-paragraphIndent": "0px",
    "--sjs-article-font-large-textCase": "none",
    "--sjs-article-font-medium-textDecoration": "none",
    "--sjs-article-font-medium-fontWeight": "700",
    "--sjs-article-font-medium-fontStyle": "normal",
    "--sjs-article-font-medium-fontStretch": "normal",
    "--sjs-article-font-medium-letterSpacing": "0",
    "--sjs-article-font-medium-lineHeight": "32px",
    "--sjs-article-font-medium-paragraphIndent": "0px",
    "--sjs-article-font-medium-textCase": "none",
    "--sjs-article-font-default-textDecoration": "none",
    "--sjs-article-font-default-fontWeight": "400",
    "--sjs-article-font-default-fontStyle": "normal",
    "--sjs-article-font-default-fontStretch": "normal",
    "--sjs-article-font-default-letterSpacing": "0",
    "--sjs-article-font-default-lineHeight": "28px",
    "--sjs-article-font-default-paragraphIndent": "0px",
    "--sjs-article-font-default-textCase": "none",
    "--sjs2-color-component-action-brand-tertiary-surface-default-bg": "rgba(238, 238, 238, 1)",
    "--sjs2-color-component-action-brand-tertiary-surface-hovered-bg": "rgba(220, 220, 220, 1)",
    "--sjs2-layout-component-page-content-area-gap-horizontal": "var(--sjs2-spacing-large-horizontal)",
    "--sjs2-layout-component-page-content-area-gap-vertical": "var(--sjs2-spacing-large-vertical)",
    "--sjs2-layout-component-panel-simple-box-gap-vertical": "var(--sjs2-spacing-medium-vertical)",
    "--sjs2-layout-component-panel-simple-content-area-padding-horizontal": "var(--sjs2-spacing-x000)",
    "--sjs2-layout-component-panel-simple-content-area-padding-top": "var(--sjs2-spacing-x000)",
    "--sjs2-layout-component-panel-simple-content-area-padding-bottom": "var(--sjs2-spacing-x000)",
    "--sjs2-layout-component-panel-simple-content-area-gap-horizontal": "var(--sjs2-spacing-x500)",
    "--sjs2-layout-component-panel-simple-nested-content-area-gap-horizontal": "var(--sjs2-spacing-x500)",
    "--sjs2-radius-component-panel-simple": "var(--sjs2-radius-x000)",
    "--sjs2-is-panelless": "true",
    "--sjs2-color-utility-surface-survey": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-panel-simple-default-bg": "transparent",
    "--sjs2-color-component-panel-simple-default-border": "transparent",
    "--sjs2-color-component-panel-default-bg": "transparent",
    "--sjs2-color-bg-basic-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-utility-property-grid": "rgba(255, 255, 255, 1)",
    "--sjs2-color-utility-tabs": "rgba(255, 255, 255, 1)",
    "--sjs2-color-utility-toolbox": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-default-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-hovered-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-default-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-hovered-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-default-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-hovered-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-basic-primary-dim": "rgba(228, 228, 228, 1)",
    "--sjs2-color-bg-neutral-tertiary-dim": "rgba(255, 255, 255, 1)",
    "--sjs2-color-utility-sheet": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-basic-secondary": "rgba(238, 238, 238, 1)",
    "--sjs2-color-bg-basic-secondary-dim": "rgba(220, 220, 220, 1)",
    "--sjs2-color-fg-basic-primary": "rgba(0, 0, 0, 0.91)",
    "--sjs2-color-fg-basic-secondary": "rgba(0, 0, 0, 0.6)",
    "--sjs2-color-component-action-alert-quaternary-surface-default-icon": "rgba(0, 0, 0, 0.6)",
    "--sjs2-color-component-action-brand-quaternary-surface-default-icon": "rgba(0, 0, 0, 0.6)",
    "--sjs2-color-component-action-neutral-quaternary-surface-default-icon": "rgba(0, 0, 0, 0.6)",
    "--sjs2-color-project-brand-600": "rgba(103, 58, 176, 1)",
    "--sjs2-color-component-tagbox-item-default-bg": "rgba(103, 58, 176, 1)",
    "--sjs2-color-component-tagbox-item-hovered-bg": "rgba(103, 58, 176, 1)",
    "--sjs2-color-bg-brand-secondary": "rgba(103, 58, 176, 0.1)",
    "--sjs2-color-bg-brand-primary-dim": "rgba(69, 24, 142, 1)",
    "--sjs2-color-fg-brand-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-default-label": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-hovered-label": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-action-hovered-icon": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-action-pressed-icon": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-action-default-icon": "rgba(255, 255, 255, 1)",
    "--sjs2-color-fg-brand-primary-disabled": "rgba(255, 255, 255, 0.25)",
    "--sjs2-color-component-tagbox-item-action-hovered-bg": "rgba(255, 255, 255, 0.25)",
    "--sjs2-base-unit-size": "8px",
    "--sjs2-base-unit-spacing": "8px",
    "--sjs2-base-unit-radius": "4px",
    "--sjs2-border-effect-surface-default": "0px 0px 0px 1px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-panel-default": "0px 0px 0px 1px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-default": "0px 0px 0px 1px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-hovered": "0px 0px 0px 1px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-disabled": "0px 0px 0px 1px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-primary-default": "0px 0px 0px 1px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-primary-hovered": "0px 0px 0px 1px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-primary-disabled": "0px 0px 0px 1px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-floating-default": "0px 2px 6px 0px rgba(0, 0, 0, 0.1),0px 8px 16px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-formbox-default": "0px 0px 0px 1px rgba(0, 0, 0, 0.25)",
    "--sjs2-border-effect-component-formbox-hovered": "0px 0px 0px 1px rgba(0, 0, 0, 0.25)",
    "--sjs2-border-effect-component-checkbox-true-default": "0px 0px 0px 1px rgba(0, 0, 0, 0.25)",
    "--sjs2-border-effect-component-checkbox-false-default": "0px 0px 0px 1px rgba(0, 0, 0, 0.25)",
    "--sjs2-border-effect-component-radio-true-default": "0px 0px 0px 1px rgba(0, 0, 0, 0.25)",
    "--sjs2-border-effect-component-radio-false-default": "0px 0px 0px 1px rgba(0, 0, 0, 0.25)",
    "--sjs2-color-border-basic-secondary": "rgba(0, 0, 0, 0.25)",
    "--sjs2-color-component-input-default-line": "rgba(0, 0, 0, 0.25)",
    "--sjs2-color-border-basic-secondary-overlay": "rgba(0, 0, 0, 0.16)",
    "--sjs2-color-bg-alert-primary": "rgba(229, 10, 62, 1)",
    "--sjs2-color-bg-alert-secondary": "rgba(229, 10, 62, 0.1)",
    "--sjs2-color-fg-alert-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-positive-primary": "rgba(25, 179, 148, 1)",
    "--sjs2-color-bg-positive-secondary": "rgba(25, 179, 148, 0.1)",
    "--sjs2-color-fg-positive-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-note-primary": "rgba(67, 127, 217, 1)",
    "--sjs2-color-bg-note-secondary": "rgba(67, 127, 217, 0.1)",
    "--sjs2-color-fg-note-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-warning-primary": "rgba(255, 152, 20, 1)",
    "--sjs2-color-bg-warning-secondary": "rgba(255, 152, 20, 0.1)",
    "--sjs2-color-fg-warning-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-radius-component-panel": "4px",
    "--sjs2-radius-component-formbox": "4px",
    "--sjs2-radius-component-action": "4px"
  }
};

export const SharpDarkPanelless = {
  "themeName": "sharp",
  "colorPalette": "dark",
  "isPanelless": true,
  "cssVariables": {
    "--sjs-general-dim-forecolor": "rgba(255, 255, 255, 0.8)",
    "--sjs-general-dim-forecolor-light": "rgba(255, 255, 255, 0.55)",
    "--sjs-secondary-backcolor": "rgba(255, 152, 20, 1)",
    "--sjs-secondary-backcolor-light": "rgba(255, 152, 20, 0.1)",
    "--sjs-secondary-backcolor-semi-light": "rgba(255, 152, 20, 0.25)",
    "--sjs-secondary-forecolor": "rgba(48, 48, 48, 1)",
    "--sjs-secondary-forecolor-light": "rgba(48, 48, 48, 0.25)",
    "--sjs-shadow-small-reset": "0px 0px 0px 0px rgba(255, 255, 255, 0.28)",
    "--sjs-shadow-inner-reset": "0px 0px 0px 0px rgba(255, 255, 255, 0.22)",
    "--sjs-article-font-xx-large-textDecoration": "none",
    "--sjs-article-font-xx-large-fontWeight": "700",
    "--sjs-article-font-xx-large-fontStyle": "normal",
    "--sjs-article-font-xx-large-fontStretch": "normal",
    "--sjs-article-font-xx-large-letterSpacing": "0",
    "--sjs-article-font-xx-large-lineHeight": "64px",
    "--sjs-article-font-xx-large-paragraphIndent": "0px",
    "--sjs-article-font-xx-large-textCase": "none",
    "--sjs-article-font-x-large-textDecoration": "none",
    "--sjs-article-font-x-large-fontWeight": "700",
    "--sjs-article-font-x-large-fontStyle": "normal",
    "--sjs-article-font-x-large-fontStretch": "normal",
    "--sjs-article-font-x-large-letterSpacing": "0",
    "--sjs-article-font-x-large-lineHeight": "56px",
    "--sjs-article-font-x-large-paragraphIndent": "0px",
    "--sjs-article-font-x-large-textCase": "none",
    "--sjs-article-font-large-textDecoration": "none",
    "--sjs-article-font-large-fontWeight": "700",
    "--sjs-article-font-large-fontStyle": "normal",
    "--sjs-article-font-large-fontStretch": "normal",
    "--sjs-article-font-large-letterSpacing": "0",
    "--sjs-article-font-large-lineHeight": "40px",
    "--sjs-article-font-large-paragraphIndent": "0px",
    "--sjs-article-font-large-textCase": "none",
    "--sjs-article-font-medium-textDecoration": "none",
    "--sjs-article-font-medium-fontWeight": "700",
    "--sjs-article-font-medium-fontStyle": "normal",
    "--sjs-article-font-medium-fontStretch": "normal",
    "--sjs-article-font-medium-letterSpacing": "0",
    "--sjs-article-font-medium-lineHeight": "32px",
    "--sjs-article-font-medium-paragraphIndent": "0px",
    "--sjs-article-font-medium-textCase": "none",
    "--sjs-article-font-default-textDecoration": "none",
    "--sjs-article-font-default-fontWeight": "400",
    "--sjs-article-font-default-fontStyle": "normal",
    "--sjs-article-font-default-fontStretch": "normal",
    "--sjs-article-font-default-letterSpacing": "0",
    "--sjs-article-font-default-lineHeight": "28px",
    "--sjs-article-font-default-paragraphIndent": "0px",
    "--sjs-article-font-default-textCase": "none",
    "--sjs2-color-component-action-brand-tertiary-surface-default-bg": "rgba(33, 33, 33, 1)",
    "--sjs2-color-component-action-brand-tertiary-surface-hovered-bg": "rgba(47, 47, 47, 1)",
    "--sjs2-layout-component-page-content-area-gap-horizontal": "var(--sjs2-spacing-large-horizontal)",
    "--sjs2-layout-component-page-content-area-gap-vertical": "var(--sjs2-spacing-large-vertical)",
    "--sjs2-layout-component-panel-simple-box-gap-vertical": "var(--sjs2-spacing-medium-vertical)",
    "--sjs2-layout-component-panel-simple-content-area-padding-horizontal": "var(--sjs2-spacing-x000)",
    "--sjs2-layout-component-panel-simple-content-area-padding-top": "var(--sjs2-spacing-x000)",
    "--sjs2-layout-component-panel-simple-content-area-padding-bottom": "var(--sjs2-spacing-x000)",
    "--sjs2-layout-component-panel-simple-content-area-gap-horizontal": "var(--sjs2-spacing-x500)",
    "--sjs2-layout-component-panel-simple-nested-content-area-gap-horizontal": "var(--sjs2-spacing-x500)",
    "--sjs2-radius-component-panel-simple": "var(--sjs2-radius-x000)",
    "--sjs2-is-panelless": "true",
    "--sjs2-color-utility-surface-survey": "rgba(48, 48, 48, 1)",
    "--sjs2-color-component-panel-simple-default-bg": "transparent",
    "--sjs2-color-component-panel-simple-default-border": "transparent",
    "--sjs2-color-component-panel-default-bg": "transparent",
    "--sjs2-color-bg-basic-primary": "rgba(48, 48, 48, 1)",
    "--sjs2-color-utility-property-grid": "rgba(48, 48, 48, 1)",
    "--sjs2-color-utility-tabs": "rgba(48, 48, 48, 1)",
    "--sjs2-color-utility-toolbox": "rgba(48, 48, 48, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-default-bg": "rgba(48, 48, 48, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-hovered-bg": "rgba(48, 48, 48, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-default-bg": "rgba(48, 48, 48, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-hovered-bg": "rgba(48, 48, 48, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-default-bg": "rgba(48, 48, 48, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-hovered-bg": "rgba(48, 48, 48, 1)",
    "--sjs2-color-bg-basic-primary-dim": "rgba(58, 58, 58, 1)",
    "--sjs2-color-bg-neutral-tertiary-dim": "rgba(48, 48, 48, 1)",
    "--sjs2-color-utility-sheet": "rgba(48, 48, 48, 1)",
    "--sjs2-color-bg-basic-secondary": "rgba(33, 33, 33, 1)",
    "--sjs2-color-bg-basic-secondary-dim": "rgba(47, 47, 47, 1)",
    "--sjs2-color-fg-basic-primary": "rgba(255, 255, 255, 0.78)",
    "--sjs2-color-fg-basic-secondary": "rgba(255, 255, 255, 0.5)",
    "--sjs2-color-component-action-alert-quaternary-surface-default-icon": "rgba(255, 255, 255, 0.5)",
    "--sjs2-color-component-action-brand-quaternary-surface-default-icon": "rgba(255, 255, 255, 0.5)",
    "--sjs2-color-component-action-neutral-quaternary-surface-default-icon": "rgba(255, 255, 255, 0.5)",
    "--sjs2-color-project-brand-600": "rgba(16, 226, 255, 1)",
    "--sjs2-color-component-tagbox-item-default-bg": "rgba(16, 226, 255, 1)",
    "--sjs2-color-component-tagbox-item-hovered-bg": "rgba(16, 226, 255, 1)",
    "--sjs2-color-bg-brand-secondary": "rgba(0, 0, 0, 0.35)",
    "--sjs2-color-bg-brand-primary-dim": "rgba(129, 240, 255, 1)",
    "--sjs2-color-fg-brand-on-primary": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-default-label": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-hovered-label": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-action-hovered-icon": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-action-pressed-icon": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-action-default-icon": "rgba(32, 32, 32, 1)",
    "--sjs2-color-fg-brand-primary-disabled": "rgba(32, 32, 32, 0.25)",
    "--sjs2-color-component-tagbox-item-action-hovered-bg": "rgba(32, 32, 32, 0.25)",
    "--sjs2-base-unit-size": "8px",
    "--sjs2-base-unit-spacing": "8px",
    "--sjs2-base-unit-radius": "4px",
    "--sjs2-border-effect-surface-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.28)",
    "--sjs2-border-effect-component-panel-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.28)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.28)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-hovered": "0px 0px 0px 1px rgba(255, 255, 255, 0.28)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-disabled": "0px 0px 0px 1px rgba(255, 255, 255, 0.28)",
    "--sjs2-border-effect-component-action-brand-primary-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.28)",
    "--sjs2-border-effect-component-action-brand-primary-hovered": "0px 0px 0px 1px rgba(255, 255, 255, 0.28)",
    "--sjs2-border-effect-component-action-brand-primary-disabled": "0px 0px 0px 1px rgba(255, 255, 255, 0.28)",
    "--sjs2-border-effect-floating-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.25),0px 2px 6px 0px rgba(0, 0, 0, 0.2),0px 8px 16px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-formbox-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.22)",
    "--sjs2-border-effect-component-formbox-hovered": "0px 0px 0px 1px rgba(255, 255, 255, 0.22)",
    "--sjs2-border-effect-component-checkbox-true-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.22)",
    "--sjs2-border-effect-component-checkbox-false-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.22)",
    "--sjs2-border-effect-component-radio-true-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.22)",
    "--sjs2-border-effect-component-radio-false-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.22)",
    "--sjs2-color-border-basic-secondary": "rgba(255, 255, 255, 0.22)",
    "--sjs2-color-component-input-default-line": "rgba(255, 255, 255, 0.22)",
    "--sjs2-color-border-basic-secondary-overlay": "rgba(255, 255, 255, 0.08)",
    "--sjs2-color-bg-alert-primary": "rgba(254, 76, 108, 1)",
    "--sjs2-color-bg-alert-secondary": "rgba(254, 76, 108, 0.1)",
    "--sjs2-color-fg-alert-on-primary": "rgba(48, 48, 48, 1)",
    "--sjs2-color-bg-positive-primary": "rgba(36, 197, 164, 1)",
    "--sjs2-color-bg-positive-secondary": "rgba(36, 197, 164, 0.1)",
    "--sjs2-color-fg-positive-on-primary": "rgba(48, 48, 48, 1)",
    "--sjs2-color-bg-note-primary": "rgba(91, 151, 242, 1)",
    "--sjs2-color-bg-note-secondary": "rgba(91, 151, 242, 0.1)",
    "--sjs2-color-fg-note-on-primary": "rgba(48, 48, 48, 1)",
    "--sjs2-color-bg-warning-primary": "rgba(255, 152, 20, 1)",
    "--sjs2-color-bg-warning-secondary": "rgba(255, 152, 20, 0.1)",
    "--sjs2-color-fg-warning-on-primary": "rgba(48, 48, 48, 1)",
    "--sjs2-radius-component-panel": "4px",
    "--sjs2-radius-component-formbox": "4px",
    "--sjs2-radius-component-action": "4px"
  }
};

export const DoubleBorderLight = {
  "themeName": "doubleborder",
  "colorPalette": "light",
  "cssVariables": {
    "--sjs-general-dim-forecolor": "rgba(0, 0, 0, 0.91)",
    "--sjs-general-dim-forecolor-light": "rgba(0, 0, 0, 0.45)",
    "--sjs-secondary-backcolor": "rgba(255, 152, 20, 1)",
    "--sjs-secondary-backcolor-light": "rgba(255, 152, 20, 0.1)",
    "--sjs-secondary-backcolor-semi-light": "rgba(255, 152, 20, 0.25)",
    "--sjs-secondary-forecolor": "rgba(255, 255, 255, 1)",
    "--sjs-secondary-forecolor-light": "rgba(255, 255, 255, 0.25)",
    "--sjs-shadow-small-reset": "0px 0px 0px 0px rgba(0, 0, 0, 0.07)",
    "--sjs-shadow-inner-reset": "0px 0px 0px 0px rgba(0, 0, 0, 0.1)",
    "--sjs-article-font-xx-large-textDecoration": "none",
    "--sjs-article-font-xx-large-fontWeight": "700",
    "--sjs-article-font-xx-large-fontStyle": "normal",
    "--sjs-article-font-xx-large-fontStretch": "normal",
    "--sjs-article-font-xx-large-letterSpacing": "0",
    "--sjs-article-font-xx-large-lineHeight": "64px",
    "--sjs-article-font-xx-large-paragraphIndent": "0px",
    "--sjs-article-font-xx-large-textCase": "none",
    "--sjs-article-font-x-large-textDecoration": "none",
    "--sjs-article-font-x-large-fontWeight": "700",
    "--sjs-article-font-x-large-fontStyle": "normal",
    "--sjs-article-font-x-large-fontStretch": "normal",
    "--sjs-article-font-x-large-letterSpacing": "0",
    "--sjs-article-font-x-large-lineHeight": "56px",
    "--sjs-article-font-x-large-paragraphIndent": "0px",
    "--sjs-article-font-x-large-textCase": "none",
    "--sjs-article-font-large-textDecoration": "none",
    "--sjs-article-font-large-fontWeight": "700",
    "--sjs-article-font-large-fontStyle": "normal",
    "--sjs-article-font-large-fontStretch": "normal",
    "--sjs-article-font-large-letterSpacing": "0",
    "--sjs-article-font-large-lineHeight": "40px",
    "--sjs-article-font-large-paragraphIndent": "0px",
    "--sjs-article-font-large-textCase": "none",
    "--sjs-article-font-medium-textDecoration": "none",
    "--sjs-article-font-medium-fontWeight": "700",
    "--sjs-article-font-medium-fontStyle": "normal",
    "--sjs-article-font-medium-fontStretch": "normal",
    "--sjs-article-font-medium-letterSpacing": "0",
    "--sjs-article-font-medium-lineHeight": "32px",
    "--sjs-article-font-medium-paragraphIndent": "0px",
    "--sjs-article-font-medium-textCase": "none",
    "--sjs-article-font-default-textDecoration": "none",
    "--sjs-article-font-default-fontWeight": "400",
    "--sjs-article-font-default-fontStyle": "normal",
    "--sjs-article-font-default-fontStretch": "normal",
    "--sjs-article-font-default-letterSpacing": "0",
    "--sjs-article-font-default-lineHeight": "28px",
    "--sjs-article-font-default-paragraphIndent": "0px",
    "--sjs-article-font-default-textCase": "none",
    "--sjs2-color-component-action-brand-tertiary-surface-default-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-brand-tertiary-surface-hovered-bg": "rgba(239, 239, 239, 1)",
    "--sjs2-color-bg-basic-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-utility-property-grid": "rgba(255, 255, 255, 1)",
    "--sjs2-color-utility-tabs": "rgba(255, 255, 255, 1)",
    "--sjs2-color-utility-toolbox": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-default-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-hovered-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-default-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-hovered-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-default-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-hovered-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-basic-primary-dim": "rgba(239, 239, 239, 1)",
    "--sjs2-color-bg-neutral-tertiary-dim": "rgba(245, 245, 245, 1)",
    "--sjs2-color-utility-sheet": "rgba(245, 245, 245, 1)",
    "--sjs2-color-utility-surface-survey": "rgba(245, 245, 245, 1)",
    "--sjs2-color-bg-basic-secondary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-basic-secondary-dim": "rgba(237, 237, 237, 1)",
    "--sjs2-color-fg-basic-primary": "rgba(0, 0, 0, 0.91)",
    "--sjs2-color-fg-basic-secondary": "rgba(0, 0, 0, 0.45)",
    "--sjs2-color-component-action-alert-quaternary-surface-default-icon": "rgba(0, 0, 0, 0.45)",
    "--sjs2-color-component-action-brand-quaternary-surface-default-icon": "rgba(0, 0, 0, 0.45)",
    "--sjs2-color-component-action-neutral-quaternary-surface-default-icon": "rgba(0, 0, 0, 0.45)",
    "--sjs2-color-project-brand-600": "rgba(76, 100, 137, 1)",
    "--sjs2-color-component-tagbox-item-default-bg": "rgba(76, 100, 137, 1)",
    "--sjs2-color-component-tagbox-item-hovered-bg": "rgba(76, 100, 137, 1)",
    "--sjs2-color-bg-brand-secondary": "rgba(76, 100, 137, 0.1)",
    "--sjs2-color-bg-brand-primary-dim": "rgba(62, 83, 115, 1)",
    "--sjs2-color-fg-brand-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-default-label": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-hovered-label": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-action-hovered-icon": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-action-pressed-icon": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-action-default-icon": "rgba(255, 255, 255, 1)",
    "--sjs2-color-fg-brand-primary-disabled": "rgba(255, 255, 255, 0.25)",
    "--sjs2-color-component-tagbox-item-action-hovered-bg": "rgba(255, 255, 255, 0.25)",
    "--sjs2-base-unit-size": "8px",
    "--sjs2-base-unit-spacing": "8px",
    "--sjs2-base-unit-radius": "4px",
    "--sjs2-border-effect-surface-default": "0px 0px 0px 2px rgba(0, 0, 0, 0.07)",
    "--sjs2-border-effect-component-panel-default": "0px 0px 0px 2px rgba(0, 0, 0, 0.07)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-default": "0px 0px 0px 2px rgba(0, 0, 0, 0.07)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-hovered": "0px 0px 0px 2px rgba(0, 0, 0, 0.07)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-disabled": "0px 0px 0px 2px rgba(0, 0, 0, 0.07)",
    "--sjs2-border-effect-component-action-brand-primary-default": "0px 0px 0px 2px rgba(0, 0, 0, 0.07)",
    "--sjs2-border-effect-component-action-brand-primary-hovered": "0px 0px 0px 2px rgba(0, 0, 0, 0.07)",
    "--sjs2-border-effect-component-action-brand-primary-disabled": "0px 0px 0px 2px rgba(0, 0, 0, 0.07)",
    "--sjs2-border-effect-floating-default": "0px 0px 0px 2px rgba(0, 0, 0, 0.08),0px 2px 6px 0px rgba(0, 0, 0, 0.04),0px 8px 16px 0px rgba(0, 0, 0, 0.08)",
    "--sjs2-border-effect-component-formbox-default": "0px 0px 0px 2px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-formbox-hovered": "0px 0px 0px 2px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-checkbox-true-default": "0px 0px 0px 2px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-checkbox-false-default": "0px 0px 0px 2px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-radio-true-default": "0px 0px 0px 2px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-radio-false-default": "0px 0px 0px 2px rgba(0, 0, 0, 0.1)",
    "--sjs2-color-border-basic-secondary": "rgba(0, 0, 0, 0.1)",
    "--sjs2-color-component-input-default-line": "rgba(0, 0, 0, 0.1)",
    "--sjs2-color-border-basic-secondary-overlay": "rgba(0, 0, 0, 0.16)",
    "--sjs2-color-bg-alert-primary": "rgba(229, 10, 62, 1)",
    "--sjs2-color-bg-alert-secondary": "rgba(229, 10, 62, 0.1)",
    "--sjs2-color-fg-alert-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-positive-primary": "rgba(25, 179, 148, 1)",
    "--sjs2-color-bg-positive-secondary": "rgba(25, 179, 148, 0.1)",
    "--sjs2-color-fg-positive-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-note-primary": "rgba(67, 127, 217, 1)",
    "--sjs2-color-bg-note-secondary": "rgba(67, 127, 217, 0.1)",
    "--sjs2-color-fg-note-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-warning-primary": "rgba(255, 152, 20, 1)",
    "--sjs2-color-bg-warning-secondary": "rgba(255, 152, 20, 0.1)",
    "--sjs2-color-fg-warning-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-radius-component-panel": "4px",
    "--sjs2-radius-component-formbox": "4px",
    "--sjs2-radius-component-action": "4px"
  }
};

export const DoubleBorderDark = {
  "themeName": "doubleborder",
  "colorPalette": "dark",
  "cssVariables": {
    "--sjs-general-dim-forecolor": "rgba(255, 255, 255, 0.79)",
    "--sjs-general-dim-forecolor-light": "rgba(255, 255, 255, 0.45)",
    "--sjs-secondary-backcolor": "rgba(255, 152, 20, 1)",
    "--sjs-secondary-backcolor-light": "rgba(255, 152, 20, 0.1)",
    "--sjs-secondary-backcolor-semi-light": "rgba(255, 152, 20, 0.25)",
    "--sjs-secondary-forecolor": "rgba(48, 48, 48, 1)",
    "--sjs-secondary-forecolor-light": "rgba(48, 48, 48, 0.25)",
    "--sjs-shadow-small-reset": "0px 0px 0px 0px rgba(255, 255, 255, 0.12)",
    "--sjs-shadow-inner-reset": "0px 0px 0px 0px rgba(255, 255, 255, 0.1)",
    "--sjs-article-font-xx-large-textDecoration": "none",
    "--sjs-article-font-xx-large-fontWeight": "700",
    "--sjs-article-font-xx-large-fontStyle": "normal",
    "--sjs-article-font-xx-large-fontStretch": "normal",
    "--sjs-article-font-xx-large-letterSpacing": "0",
    "--sjs-article-font-xx-large-lineHeight": "64px",
    "--sjs-article-font-xx-large-paragraphIndent": "0px",
    "--sjs-article-font-xx-large-textCase": "none",
    "--sjs-article-font-x-large-textDecoration": "none",
    "--sjs-article-font-x-large-fontWeight": "700",
    "--sjs-article-font-x-large-fontStyle": "normal",
    "--sjs-article-font-x-large-fontStretch": "normal",
    "--sjs-article-font-x-large-letterSpacing": "0",
    "--sjs-article-font-x-large-lineHeight": "56px",
    "--sjs-article-font-x-large-paragraphIndent": "0px",
    "--sjs-article-font-x-large-textCase": "none",
    "--sjs-article-font-large-textDecoration": "none",
    "--sjs-article-font-large-fontWeight": "700",
    "--sjs-article-font-large-fontStyle": "normal",
    "--sjs-article-font-large-fontStretch": "normal",
    "--sjs-article-font-large-letterSpacing": "0",
    "--sjs-article-font-large-lineHeight": "40px",
    "--sjs-article-font-large-paragraphIndent": "0px",
    "--sjs-article-font-large-textCase": "none",
    "--sjs-article-font-medium-textDecoration": "none",
    "--sjs-article-font-medium-fontWeight": "700",
    "--sjs-article-font-medium-fontStyle": "normal",
    "--sjs-article-font-medium-fontStretch": "normal",
    "--sjs-article-font-medium-letterSpacing": "0",
    "--sjs-article-font-medium-lineHeight": "32px",
    "--sjs-article-font-medium-paragraphIndent": "0px",
    "--sjs-article-font-medium-textCase": "none",
    "--sjs-article-font-default-textDecoration": "none",
    "--sjs-article-font-default-fontWeight": "400",
    "--sjs-article-font-default-fontStyle": "normal",
    "--sjs-article-font-default-fontStretch": "normal",
    "--sjs-article-font-default-letterSpacing": "0",
    "--sjs-article-font-default-lineHeight": "28px",
    "--sjs-article-font-default-paragraphIndent": "0px",
    "--sjs-article-font-default-textCase": "none",
    "--sjs2-color-component-action-brand-tertiary-surface-default-bg": "rgba(52, 52, 52, 1)",
    "--sjs2-color-component-action-brand-tertiary-surface-hovered-bg": "rgba(58, 58, 58, 1)",
    "--sjs2-color-bg-basic-primary": "rgba(52, 52, 52, 1)",
    "--sjs2-color-utility-property-grid": "rgba(52, 52, 52, 1)",
    "--sjs2-color-utility-tabs": "rgba(52, 52, 52, 1)",
    "--sjs2-color-utility-toolbox": "rgba(52, 52, 52, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-default-bg": "rgba(52, 52, 52, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-hovered-bg": "rgba(52, 52, 52, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-default-bg": "rgba(52, 52, 52, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-hovered-bg": "rgba(52, 52, 52, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-default-bg": "rgba(52, 52, 52, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-hovered-bg": "rgba(52, 52, 52, 1)",
    "--sjs2-color-bg-basic-primary-dim": "rgba(58, 58, 58, 1)",
    "--sjs2-color-bg-neutral-tertiary-dim": "rgba(47, 47, 47, 1)",
    "--sjs2-color-utility-sheet": "rgba(47, 47, 47, 1)",
    "--sjs2-color-utility-surface-survey": "rgba(47, 47, 47, 1)",
    "--sjs2-color-bg-basic-secondary": "rgba(47, 47, 47, 1)",
    "--sjs2-color-bg-basic-secondary-dim": "rgba(53, 53, 53, 1)",
    "--sjs2-color-fg-basic-primary": "rgba(255, 255, 255, 0.78)",
    "--sjs2-color-fg-basic-secondary": "rgba(255, 255, 255, 0.42)",
    "--sjs2-color-component-action-alert-quaternary-surface-default-icon": "rgba(255, 255, 255, 0.42)",
    "--sjs2-color-component-action-brand-quaternary-surface-default-icon": "rgba(255, 255, 255, 0.42)",
    "--sjs2-color-component-action-neutral-quaternary-surface-default-icon": "rgba(255, 255, 255, 0.42)",
    "--sjs2-color-project-brand-600": "rgba(120, 156, 210, 1)",
    "--sjs2-color-component-tagbox-item-default-bg": "rgba(120, 156, 210, 1)",
    "--sjs2-color-component-tagbox-item-hovered-bg": "rgba(120, 156, 210, 1)",
    "--sjs2-color-bg-brand-secondary": "rgba(255, 255, 255, 0.1)",
    "--sjs2-color-bg-brand-primary-dim": "rgba(146, 181, 235, 1)",
    "--sjs2-color-fg-brand-on-primary": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-default-label": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-hovered-label": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-action-hovered-icon": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-action-pressed-icon": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-action-default-icon": "rgba(32, 32, 32, 1)",
    "--sjs2-color-fg-brand-primary-disabled": "rgba(32, 32, 32, 0.25)",
    "--sjs2-color-component-tagbox-item-action-hovered-bg": "rgba(32, 32, 32, 0.25)",
    "--sjs2-base-unit-size": "8px",
    "--sjs2-base-unit-spacing": "8px",
    "--sjs2-base-unit-radius": "4px",
    "--sjs2-border-effect-surface-default": "0px 0px 0px 2px rgba(255, 255, 255, 0.12)",
    "--sjs2-border-effect-component-panel-default": "0px 0px 0px 2px rgba(255, 255, 255, 0.12)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-default": "0px 0px 0px 2px rgba(255, 255, 255, 0.12)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-hovered": "0px 0px 0px 2px rgba(255, 255, 255, 0.12)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-disabled": "0px 0px 0px 2px rgba(255, 255, 255, 0.12)",
    "--sjs2-border-effect-component-action-brand-primary-default": "0px 0px 0px 2px rgba(255, 255, 255, 0.12)",
    "--sjs2-border-effect-component-action-brand-primary-hovered": "0px 0px 0px 2px rgba(255, 255, 255, 0.12)",
    "--sjs2-border-effect-component-action-brand-primary-disabled": "0px 0px 0px 2px rgba(255, 255, 255, 0.12)",
    "--sjs2-border-effect-floating-default": "0px 0px 0px 2px rgba(255, 255, 255, 0.1),0px 8px 16px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-formbox-default": "0px 0px 0px 2px rgba(255, 255, 255, 0.1)",
    "--sjs2-border-effect-component-formbox-hovered": "0px 0px 0px 2px rgba(255, 255, 255, 0.1)",
    "--sjs2-border-effect-component-checkbox-true-default": "0px 0px 0px 2px rgba(255, 255, 255, 0.1)",
    "--sjs2-border-effect-component-checkbox-false-default": "0px 0px 0px 2px rgba(255, 255, 255, 0.1)",
    "--sjs2-border-effect-component-radio-true-default": "0px 0px 0px 2px rgba(255, 255, 255, 0.1)",
    "--sjs2-border-effect-component-radio-false-default": "0px 0px 0px 2px rgba(255, 255, 255, 0.1)",
    "--sjs2-color-border-basic-secondary": "rgba(255, 255, 255, 0.1)",
    "--sjs2-color-component-input-default-line": "rgba(255, 255, 255, 0.1)",
    "--sjs2-color-border-basic-secondary-overlay": "rgba(255, 255, 255, 0.08)",
    "--sjs2-color-bg-alert-primary": "rgba(254, 76, 108, 1)",
    "--sjs2-color-bg-alert-secondary": "rgba(254, 76, 108, 0.1)",
    "--sjs2-color-fg-alert-on-primary": "rgba(48, 48, 48, 1)",
    "--sjs2-color-bg-positive-primary": "rgba(36, 197, 164, 1)",
    "--sjs2-color-bg-positive-secondary": "rgba(36, 197, 164, 0.1)",
    "--sjs2-color-fg-positive-on-primary": "rgba(48, 48, 48, 1)",
    "--sjs2-color-bg-note-primary": "rgba(91, 151, 242, 1)",
    "--sjs2-color-bg-note-secondary": "rgba(91, 151, 242, 0.1)",
    "--sjs2-color-fg-note-on-primary": "rgba(48, 48, 48, 1)",
    "--sjs2-color-bg-warning-primary": "rgba(255, 152, 20, 1)",
    "--sjs2-color-bg-warning-secondary": "rgba(255, 152, 20, 0.1)",
    "--sjs2-color-fg-warning-on-primary": "rgba(48, 48, 48, 1)",
    "--sjs2-radius-component-panel": "4px",
    "--sjs2-radius-component-formbox": "4px",
    "--sjs2-radius-component-action": "4px"
  }
};

export const DoubleBorderLightPanelless = {
  "themeName": "doubleborder",
  "colorPalette": "light",
  "isPanelless": true,
  "cssVariables": {
    "--sjs-general-dim-forecolor": "rgba(0, 0, 0, 0.91)",
    "--sjs-general-dim-forecolor-light": "rgba(0, 0, 0, 0.45)",
    "--sjs-secondary-backcolor": "rgba(255, 152, 20, 1)",
    "--sjs-secondary-backcolor-light": "rgba(255, 152, 20, 0.1)",
    "--sjs-secondary-backcolor-semi-light": "rgba(255, 152, 20, 0.25)",
    "--sjs-secondary-forecolor": "rgba(255, 255, 255, 1)",
    "--sjs-secondary-forecolor-light": "rgba(255, 255, 255, 0.25)",
    "--sjs-shadow-small-reset": "0px 0px 0px 0px rgba(0, 0, 0, 0.07)",
    "--sjs-shadow-inner-reset": "0px 0px 0px 0px rgba(0, 0, 0, 0.1)",
    "--sjs-article-font-xx-large-textDecoration": "none",
    "--sjs-article-font-xx-large-fontWeight": "700",
    "--sjs-article-font-xx-large-fontStyle": "normal",
    "--sjs-article-font-xx-large-fontStretch": "normal",
    "--sjs-article-font-xx-large-letterSpacing": "0",
    "--sjs-article-font-xx-large-lineHeight": "64px",
    "--sjs-article-font-xx-large-paragraphIndent": "0px",
    "--sjs-article-font-xx-large-textCase": "none",
    "--sjs-article-font-x-large-textDecoration": "none",
    "--sjs-article-font-x-large-fontWeight": "700",
    "--sjs-article-font-x-large-fontStyle": "normal",
    "--sjs-article-font-x-large-fontStretch": "normal",
    "--sjs-article-font-x-large-letterSpacing": "0",
    "--sjs-article-font-x-large-lineHeight": "56px",
    "--sjs-article-font-x-large-paragraphIndent": "0px",
    "--sjs-article-font-x-large-textCase": "none",
    "--sjs-article-font-large-textDecoration": "none",
    "--sjs-article-font-large-fontWeight": "700",
    "--sjs-article-font-large-fontStyle": "normal",
    "--sjs-article-font-large-fontStretch": "normal",
    "--sjs-article-font-large-letterSpacing": "0",
    "--sjs-article-font-large-lineHeight": "40px",
    "--sjs-article-font-large-paragraphIndent": "0px",
    "--sjs-article-font-large-textCase": "none",
    "--sjs-article-font-medium-textDecoration": "none",
    "--sjs-article-font-medium-fontWeight": "700",
    "--sjs-article-font-medium-fontStyle": "normal",
    "--sjs-article-font-medium-fontStretch": "normal",
    "--sjs-article-font-medium-letterSpacing": "0",
    "--sjs-article-font-medium-lineHeight": "32px",
    "--sjs-article-font-medium-paragraphIndent": "0px",
    "--sjs-article-font-medium-textCase": "none",
    "--sjs-article-font-default-textDecoration": "none",
    "--sjs-article-font-default-fontWeight": "400",
    "--sjs-article-font-default-fontStyle": "normal",
    "--sjs-article-font-default-fontStretch": "normal",
    "--sjs-article-font-default-letterSpacing": "0",
    "--sjs-article-font-default-lineHeight": "28px",
    "--sjs-article-font-default-paragraphIndent": "0px",
    "--sjs-article-font-default-textCase": "none",
    "--sjs2-color-component-action-brand-tertiary-surface-default-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-brand-tertiary-surface-hovered-bg": "rgba(237, 237, 237, 1)",
    "--sjs2-layout-component-page-content-area-gap-horizontal": "var(--sjs2-spacing-large-horizontal)",
    "--sjs2-layout-component-page-content-area-gap-vertical": "var(--sjs2-spacing-large-vertical)",
    "--sjs2-layout-component-panel-simple-box-gap-vertical": "var(--sjs2-spacing-medium-vertical)",
    "--sjs2-layout-component-panel-simple-content-area-padding-horizontal": "var(--sjs2-spacing-x000)",
    "--sjs2-layout-component-panel-simple-content-area-padding-top": "var(--sjs2-spacing-x000)",
    "--sjs2-layout-component-panel-simple-content-area-padding-bottom": "var(--sjs2-spacing-x000)",
    "--sjs2-layout-component-panel-simple-content-area-gap-horizontal": "var(--sjs2-spacing-x500)",
    "--sjs2-layout-component-panel-simple-nested-content-area-gap-horizontal": "var(--sjs2-spacing-x500)",
    "--sjs2-radius-component-panel-simple": "var(--sjs2-radius-x000)",
    "--sjs2-is-panelless": "true",
    "--sjs2-color-utility-surface-survey": "rgba(245, 245, 245, 1)",
    "--sjs2-color-component-panel-simple-default-bg": "transparent",
    "--sjs2-color-component-panel-simple-default-border": "transparent",
    "--sjs2-color-component-panel-default-bg": "transparent",
    "--sjs2-color-bg-basic-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-utility-property-grid": "rgba(255, 255, 255, 1)",
    "--sjs2-color-utility-tabs": "rgba(255, 255, 255, 1)",
    "--sjs2-color-utility-toolbox": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-default-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-hovered-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-default-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-hovered-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-default-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-hovered-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-basic-primary-dim": "rgba(239, 239, 239, 1)",
    "--sjs2-color-bg-neutral-tertiary-dim": "rgba(245, 245, 245, 1)",
    "--sjs2-color-utility-sheet": "rgba(245, 245, 245, 1)",
    "--sjs2-color-bg-basic-secondary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-basic-secondary-dim": "rgba(237, 237, 237, 1)",
    "--sjs2-color-fg-basic-primary": "rgba(0, 0, 0, 0.91)",
    "--sjs2-color-fg-basic-secondary": "rgba(0, 0, 0, 0.45)",
    "--sjs2-color-component-action-alert-quaternary-surface-default-icon": "rgba(0, 0, 0, 0.45)",
    "--sjs2-color-component-action-brand-quaternary-surface-default-icon": "rgba(0, 0, 0, 0.45)",
    "--sjs2-color-component-action-neutral-quaternary-surface-default-icon": "rgba(0, 0, 0, 0.45)",
    "--sjs2-color-project-brand-600": "rgba(76, 100, 137, 1)",
    "--sjs2-color-component-tagbox-item-default-bg": "rgba(76, 100, 137, 1)",
    "--sjs2-color-component-tagbox-item-hovered-bg": "rgba(76, 100, 137, 1)",
    "--sjs2-color-bg-brand-secondary": "rgba(76, 100, 137, 0.1)",
    "--sjs2-color-bg-brand-primary-dim": "rgba(62, 83, 115, 1)",
    "--sjs2-color-fg-brand-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-default-label": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-hovered-label": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-action-hovered-icon": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-action-pressed-icon": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-action-default-icon": "rgba(255, 255, 255, 1)",
    "--sjs2-color-fg-brand-primary-disabled": "rgba(255, 255, 255, 0.25)",
    "--sjs2-color-component-tagbox-item-action-hovered-bg": "rgba(255, 255, 255, 0.25)",
    "--sjs2-base-unit-size": "8px",
    "--sjs2-base-unit-spacing": "8px",
    "--sjs2-base-unit-radius": "4px",
    "--sjs2-border-effect-surface-default": "0px 0px 0px 2px rgba(0, 0, 0, 0.07)",
    "--sjs2-border-effect-component-panel-default": "0px 0px 0px 2px rgba(0, 0, 0, 0.07)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-default": "0px 0px 0px 2px rgba(0, 0, 0, 0.07)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-hovered": "0px 0px 0px 2px rgba(0, 0, 0, 0.07)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-disabled": "0px 0px 0px 2px rgba(0, 0, 0, 0.07)",
    "--sjs2-border-effect-component-action-brand-primary-default": "0px 0px 0px 2px rgba(0, 0, 0, 0.07)",
    "--sjs2-border-effect-component-action-brand-primary-hovered": "0px 0px 0px 2px rgba(0, 0, 0, 0.07)",
    "--sjs2-border-effect-component-action-brand-primary-disabled": "0px 0px 0px 2px rgba(0, 0, 0, 0.07)",
    "--sjs2-border-effect-floating-default": "0px 0px 0px 2px rgba(0, 0, 0, 0.08),0px 2px 6px 0px rgba(0, 0, 0, 0.04),0px 8px 16px 0px rgba(0, 0, 0, 0.08)",
    "--sjs2-border-effect-component-formbox-default": "0px 0px 0px 2px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-formbox-hovered": "0px 0px 0px 2px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-checkbox-true-default": "0px 0px 0px 2px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-checkbox-false-default": "0px 0px 0px 2px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-radio-true-default": "0px 0px 0px 2px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-radio-false-default": "0px 0px 0px 2px rgba(0, 0, 0, 0.1)",
    "--sjs2-color-border-basic-secondary": "rgba(0, 0, 0, 0.1)",
    "--sjs2-color-component-input-default-line": "rgba(0, 0, 0, 0.1)",
    "--sjs2-color-border-basic-secondary-overlay": "rgba(0, 0, 0, 0.16)",
    "--sjs2-color-bg-alert-primary": "rgba(229, 10, 62, 1)",
    "--sjs2-color-bg-alert-secondary": "rgba(229, 10, 62, 0.1)",
    "--sjs2-color-fg-alert-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-positive-primary": "rgba(25, 179, 148, 1)",
    "--sjs2-color-bg-positive-secondary": "rgba(25, 179, 148, 0.1)",
    "--sjs2-color-fg-positive-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-note-primary": "rgba(67, 127, 217, 1)",
    "--sjs2-color-bg-note-secondary": "rgba(67, 127, 217, 0.1)",
    "--sjs2-color-fg-note-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-warning-primary": "rgba(255, 152, 20, 1)",
    "--sjs2-color-bg-warning-secondary": "rgba(255, 152, 20, 0.1)",
    "--sjs2-color-fg-warning-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-radius-component-panel": "4px",
    "--sjs2-radius-component-formbox": "4px",
    "--sjs2-radius-component-action": "4px"
  }
};

export const DoubleBorderDarkPanelless = {
  "themeName": "doubleborder",
  "colorPalette": "dark",
  "isPanelless": true,
  "cssVariables": {
    "--sjs-general-dim-forecolor": "rgba(255, 255, 255, 0.79)",
    "--sjs-general-dim-forecolor-light": "rgba(255, 255, 255, 0.45)",
    "--sjs-secondary-backcolor": "rgba(255, 152, 20, 1)",
    "--sjs-secondary-backcolor-light": "rgba(255, 152, 20, 0.1)",
    "--sjs-secondary-backcolor-semi-light": "rgba(255, 152, 20, 0.25)",
    "--sjs-secondary-forecolor": "rgba(48, 48, 48, 1)",
    "--sjs-secondary-forecolor-light": "rgba(48, 48, 48, 0.25)",
    "--sjs-shadow-small-reset": "0px 0px 0px 0px rgba(255, 255, 255, 0.12)",
    "--sjs-shadow-inner-reset": "0px 0px 0px 0px rgba(255, 255, 255, 0.1)",
    "--sjs-article-font-xx-large-textDecoration": "none",
    "--sjs-article-font-xx-large-fontWeight": "700",
    "--sjs-article-font-xx-large-fontStyle": "normal",
    "--sjs-article-font-xx-large-fontStretch": "normal",
    "--sjs-article-font-xx-large-letterSpacing": "0",
    "--sjs-article-font-xx-large-lineHeight": "64px",
    "--sjs-article-font-xx-large-paragraphIndent": "0px",
    "--sjs-article-font-xx-large-textCase": "none",
    "--sjs-article-font-x-large-textDecoration": "none",
    "--sjs-article-font-x-large-fontWeight": "700",
    "--sjs-article-font-x-large-fontStyle": "normal",
    "--sjs-article-font-x-large-fontStretch": "normal",
    "--sjs-article-font-x-large-letterSpacing": "0",
    "--sjs-article-font-x-large-lineHeight": "56px",
    "--sjs-article-font-x-large-paragraphIndent": "0px",
    "--sjs-article-font-x-large-textCase": "none",
    "--sjs-article-font-large-textDecoration": "none",
    "--sjs-article-font-large-fontWeight": "700",
    "--sjs-article-font-large-fontStyle": "normal",
    "--sjs-article-font-large-fontStretch": "normal",
    "--sjs-article-font-large-letterSpacing": "0",
    "--sjs-article-font-large-lineHeight": "40px",
    "--sjs-article-font-large-paragraphIndent": "0px",
    "--sjs-article-font-large-textCase": "none",
    "--sjs-article-font-medium-textDecoration": "none",
    "--sjs-article-font-medium-fontWeight": "700",
    "--sjs-article-font-medium-fontStyle": "normal",
    "--sjs-article-font-medium-fontStretch": "normal",
    "--sjs-article-font-medium-letterSpacing": "0",
    "--sjs-article-font-medium-lineHeight": "32px",
    "--sjs-article-font-medium-paragraphIndent": "0px",
    "--sjs-article-font-medium-textCase": "none",
    "--sjs-article-font-default-textDecoration": "none",
    "--sjs-article-font-default-fontWeight": "400",
    "--sjs-article-font-default-fontStyle": "normal",
    "--sjs-article-font-default-fontStretch": "normal",
    "--sjs-article-font-default-letterSpacing": "0",
    "--sjs-article-font-default-lineHeight": "28px",
    "--sjs-article-font-default-paragraphIndent": "0px",
    "--sjs-article-font-default-textCase": "none",
    "--sjs2-color-component-action-brand-tertiary-surface-default-bg": "rgba(47, 47, 47, 1)",
    "--sjs2-color-component-action-brand-tertiary-surface-hovered-bg": "rgba(53, 53, 53, 1)",
    "--sjs2-layout-component-page-content-area-gap-horizontal": "var(--sjs2-spacing-large-horizontal)",
    "--sjs2-layout-component-page-content-area-gap-vertical": "var(--sjs2-spacing-large-vertical)",
    "--sjs2-layout-component-panel-simple-box-gap-vertical": "var(--sjs2-spacing-medium-vertical)",
    "--sjs2-layout-component-panel-simple-content-area-padding-horizontal": "var(--sjs2-spacing-x000)",
    "--sjs2-layout-component-panel-simple-content-area-padding-top": "var(--sjs2-spacing-x000)",
    "--sjs2-layout-component-panel-simple-content-area-padding-bottom": "var(--sjs2-spacing-x000)",
    "--sjs2-layout-component-panel-simple-content-area-gap-horizontal": "var(--sjs2-spacing-x500)",
    "--sjs2-layout-component-panel-simple-nested-content-area-gap-horizontal": "var(--sjs2-spacing-x500)",
    "--sjs2-radius-component-panel-simple": "var(--sjs2-radius-x000)",
    "--sjs2-is-panelless": "true",
    "--sjs2-color-utility-surface-survey": "rgba(52, 52, 52, 1)",
    "--sjs2-color-component-panel-simple-default-bg": "transparent",
    "--sjs2-color-component-panel-simple-default-border": "transparent",
    "--sjs2-color-component-panel-default-bg": "transparent",
    "--sjs2-color-bg-basic-primary": "rgba(52, 52, 52, 1)",
    "--sjs2-color-utility-property-grid": "rgba(52, 52, 52, 1)",
    "--sjs2-color-utility-tabs": "rgba(52, 52, 52, 1)",
    "--sjs2-color-utility-toolbox": "rgba(52, 52, 52, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-default-bg": "rgba(52, 52, 52, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-hovered-bg": "rgba(52, 52, 52, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-default-bg": "rgba(52, 52, 52, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-hovered-bg": "rgba(52, 52, 52, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-default-bg": "rgba(52, 52, 52, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-hovered-bg": "rgba(52, 52, 52, 1)",
    "--sjs2-color-bg-basic-primary-dim": "rgba(58, 58, 58, 1)",
    "--sjs2-color-bg-neutral-tertiary-dim": "rgba(52, 52, 52, 1)",
    "--sjs2-color-utility-sheet": "rgba(52, 52, 52, 1)",
    "--sjs2-color-bg-basic-secondary": "rgba(47, 47, 47, 1)",
    "--sjs2-color-bg-basic-secondary-dim": "rgba(53, 53, 53, 1)",
    "--sjs2-color-fg-basic-primary": "rgba(255, 255, 255, 0.78)",
    "--sjs2-color-fg-basic-secondary": "rgba(255, 255, 255, 0.42)",
    "--sjs2-color-component-action-alert-quaternary-surface-default-icon": "rgba(255, 255, 255, 0.42)",
    "--sjs2-color-component-action-brand-quaternary-surface-default-icon": "rgba(255, 255, 255, 0.42)",
    "--sjs2-color-component-action-neutral-quaternary-surface-default-icon": "rgba(255, 255, 255, 0.42)",
    "--sjs2-color-project-brand-600": "rgba(120, 156, 210, 1)",
    "--sjs2-color-component-tagbox-item-default-bg": "rgba(120, 156, 210, 1)",
    "--sjs2-color-component-tagbox-item-hovered-bg": "rgba(120, 156, 210, 1)",
    "--sjs2-color-bg-brand-secondary": "rgba(255, 255, 255, 0.1)",
    "--sjs2-color-bg-brand-primary-dim": "rgba(146, 181, 235, 1)",
    "--sjs2-color-fg-brand-on-primary": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-default-label": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-hovered-label": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-action-hovered-icon": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-action-pressed-icon": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-action-default-icon": "rgba(32, 32, 32, 1)",
    "--sjs2-color-fg-brand-primary-disabled": "rgba(32, 32, 32, 0.25)",
    "--sjs2-color-component-tagbox-item-action-hovered-bg": "rgba(32, 32, 32, 0.25)",
    "--sjs2-base-unit-size": "8px",
    "--sjs2-base-unit-spacing": "8px",
    "--sjs2-base-unit-radius": "4px",
    "--sjs2-border-effect-surface-default": "0px 0px 0px 2px rgba(255, 255, 255, 0.12)",
    "--sjs2-border-effect-component-panel-default": "0px 0px 0px 2px rgba(255, 255, 255, 0.12)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-default": "0px 0px 0px 2px rgba(255, 255, 255, 0.12)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-hovered": "0px 0px 0px 2px rgba(255, 255, 255, 0.12)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-disabled": "0px 0px 0px 2px rgba(255, 255, 255, 0.12)",
    "--sjs2-border-effect-component-action-brand-primary-default": "0px 0px 0px 2px rgba(255, 255, 255, 0.12)",
    "--sjs2-border-effect-component-action-brand-primary-hovered": "0px 0px 0px 2px rgba(255, 255, 255, 0.12)",
    "--sjs2-border-effect-component-action-brand-primary-disabled": "0px 0px 0px 2px rgba(255, 255, 255, 0.12)",
    "--sjs2-border-effect-floating-default": "0px 0px 0px 2px rgba(255, 255, 255, 0.1),0px 8px 16px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-formbox-default": "0px 0px 0px 2px rgba(255, 255, 255, 0.1)",
    "--sjs2-border-effect-component-formbox-hovered": "0px 0px 0px 2px rgba(255, 255, 255, 0.1)",
    "--sjs2-border-effect-component-checkbox-true-default": "0px 0px 0px 2px rgba(255, 255, 255, 0.1)",
    "--sjs2-border-effect-component-checkbox-false-default": "0px 0px 0px 2px rgba(255, 255, 255, 0.1)",
    "--sjs2-border-effect-component-radio-true-default": "0px 0px 0px 2px rgba(255, 255, 255, 0.1)",
    "--sjs2-border-effect-component-radio-false-default": "0px 0px 0px 2px rgba(255, 255, 255, 0.1)",
    "--sjs2-color-border-basic-secondary": "rgba(255, 255, 255, 0.1)",
    "--sjs2-color-component-input-default-line": "rgba(255, 255, 255, 0.1)",
    "--sjs2-color-border-basic-secondary-overlay": "rgba(255, 255, 255, 0.08)",
    "--sjs2-color-bg-alert-primary": "rgba(254, 76, 108, 1)",
    "--sjs2-color-bg-alert-secondary": "rgba(254, 76, 108, 0.1)",
    "--sjs2-color-fg-alert-on-primary": "rgba(48, 48, 48, 1)",
    "--sjs2-color-bg-positive-primary": "rgba(36, 197, 164, 1)",
    "--sjs2-color-bg-positive-secondary": "rgba(36, 197, 164, 0.1)",
    "--sjs2-color-fg-positive-on-primary": "rgba(48, 48, 48, 1)",
    "--sjs2-color-bg-note-primary": "rgba(91, 151, 242, 1)",
    "--sjs2-color-bg-note-secondary": "rgba(91, 151, 242, 0.1)",
    "--sjs2-color-fg-note-on-primary": "rgba(48, 48, 48, 1)",
    "--sjs2-color-bg-warning-primary": "rgba(255, 152, 20, 1)",
    "--sjs2-color-bg-warning-secondary": "rgba(255, 152, 20, 0.1)",
    "--sjs2-color-fg-warning-on-primary": "rgba(48, 48, 48, 1)",
    "--sjs2-radius-component-panel": "4px",
    "--sjs2-radius-component-formbox": "4px",
    "--sjs2-radius-component-action": "4px"
  }
};

export const LayeredLight = {
  "themeName": "layered",
  "colorPalette": "light",
  "cssVariables": {
    "--sjs-general-dim-forecolor": "rgba(0, 0, 0, 0.91)",
    "--sjs-general-dim-forecolor-light": "rgba(0, 0, 0, 0.5)",
    "--sjs-secondary-backcolor": "rgba(255, 152, 20, 1)",
    "--sjs-secondary-backcolor-light": "rgba(255, 152, 20, 0.1)",
    "--sjs-secondary-backcolor-semi-light": "rgba(255, 152, 20, 0.25)",
    "--sjs-secondary-forecolor": "rgba(255, 255, 255, 1)",
    "--sjs-secondary-forecolor-light": "rgba(255, 255, 255, 0.25)",
    "--sjs-shadow-small-reset": "0px 0px 0px 0px rgba(0, 0, 0, 0.05),0px 0px 0px 0px rgba(0, 0, 0, 0.1),0px 0px 0px 0px rgba(0, 0, 0, 0.1)",
    "--sjs-shadow-inner-reset": "inset 0px 0px 0px 0px rgba(0, 0, 0, 0.05),inset 0px 0px 0px 0px rgba(0, 0, 0, 0.1)",
    "--sjs-article-font-xx-large-textDecoration": "none",
    "--sjs-article-font-xx-large-fontWeight": "700",
    "--sjs-article-font-xx-large-fontStyle": "normal",
    "--sjs-article-font-xx-large-fontStretch": "normal",
    "--sjs-article-font-xx-large-letterSpacing": "0",
    "--sjs-article-font-xx-large-lineHeight": "64px",
    "--sjs-article-font-xx-large-paragraphIndent": "0px",
    "--sjs-article-font-xx-large-textCase": "none",
    "--sjs-article-font-x-large-textDecoration": "none",
    "--sjs-article-font-x-large-fontWeight": "700",
    "--sjs-article-font-x-large-fontStyle": "normal",
    "--sjs-article-font-x-large-fontStretch": "normal",
    "--sjs-article-font-x-large-letterSpacing": "0",
    "--sjs-article-font-x-large-lineHeight": "56px",
    "--sjs-article-font-x-large-paragraphIndent": "0px",
    "--sjs-article-font-x-large-textCase": "none",
    "--sjs-article-font-large-textDecoration": "none",
    "--sjs-article-font-large-fontWeight": "700",
    "--sjs-article-font-large-fontStyle": "normal",
    "--sjs-article-font-large-fontStretch": "normal",
    "--sjs-article-font-large-letterSpacing": "0",
    "--sjs-article-font-large-lineHeight": "40px",
    "--sjs-article-font-large-paragraphIndent": "0px",
    "--sjs-article-font-large-textCase": "none",
    "--sjs-article-font-medium-textDecoration": "none",
    "--sjs-article-font-medium-fontWeight": "700",
    "--sjs-article-font-medium-fontStyle": "normal",
    "--sjs-article-font-medium-fontStretch": "normal",
    "--sjs-article-font-medium-letterSpacing": "0",
    "--sjs-article-font-medium-lineHeight": "32px",
    "--sjs-article-font-medium-paragraphIndent": "0px",
    "--sjs-article-font-medium-textCase": "none",
    "--sjs-article-font-default-textDecoration": "none",
    "--sjs-article-font-default-fontWeight": "400",
    "--sjs-article-font-default-fontStyle": "normal",
    "--sjs-article-font-default-fontStretch": "normal",
    "--sjs-article-font-default-letterSpacing": "0",
    "--sjs-article-font-default-lineHeight": "28px",
    "--sjs-article-font-default-paragraphIndent": "0px",
    "--sjs-article-font-default-textCase": "none",
    "--sjs2-color-component-action-brand-tertiary-surface-default-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-brand-tertiary-surface-hovered-bg": "rgba(244, 244, 244, 1)",
    "--sjs2-color-bg-basic-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-utility-property-grid": "rgba(255, 255, 255, 1)",
    "--sjs2-color-utility-tabs": "rgba(255, 255, 255, 1)",
    "--sjs2-color-utility-toolbox": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-default-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-hovered-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-default-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-hovered-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-default-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-hovered-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-basic-primary-dim": "rgba(244, 244, 244, 1)",
    "--sjs2-color-bg-neutral-tertiary-dim": "rgba(216, 207, 236, 1)",
    "--sjs2-color-utility-sheet": "rgba(216, 207, 236, 1)",
    "--sjs2-color-utility-surface-survey": "rgba(216, 207, 236, 1)",
    "--sjs2-color-bg-basic-secondary": "rgba(241, 237, 248, 1)",
    "--sjs2-color-bg-basic-secondary-dim": "rgba(225, 220, 233, 1)",
    "--sjs2-color-fg-basic-primary": "rgba(0, 0, 0, 0.91)",
    "--sjs2-color-fg-basic-secondary": "rgba(0, 0, 0, 0.45)",
    "--sjs2-color-component-action-alert-quaternary-surface-default-icon": "rgba(0, 0, 0, 0.45)",
    "--sjs2-color-component-action-brand-quaternary-surface-default-icon": "rgba(0, 0, 0, 0.45)",
    "--sjs2-color-component-action-neutral-quaternary-surface-default-icon": "rgba(0, 0, 0, 0.45)",
    "--sjs2-color-project-brand-600": "rgba(122, 100, 168, 1)",
    "--sjs2-color-component-tagbox-item-default-bg": "rgba(122, 100, 168, 1)",
    "--sjs2-color-component-tagbox-item-hovered-bg": "rgba(122, 100, 168, 1)",
    "--sjs2-color-bg-brand-secondary": "rgba(122, 100, 168, 0.1)",
    "--sjs2-color-bg-brand-primary-dim": "rgba(105, 84, 152, 1)",
    "--sjs2-color-fg-brand-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-default-label": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-hovered-label": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-action-hovered-icon": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-action-pressed-icon": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-action-default-icon": "rgba(255, 255, 255, 1)",
    "--sjs2-color-fg-brand-primary-disabled": "rgba(255, 255, 255, 0.25)",
    "--sjs2-color-component-tagbox-item-action-hovered-bg": "rgba(255, 255, 255, 0.25)",
    "--sjs2-base-unit-size": "8px",
    "--sjs2-base-unit-spacing": "8px",
    "--sjs2-base-unit-radius": "4px",
    "--sjs2-border-effect-surface-default": "0px 0px 0px 1px rgba(0, 0, 0, 0.05),0px 8px 16px 0px rgba(0, 0, 0, 0.1),0px 2px 4px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-panel-default": "0px 0px 0px 1px rgba(0, 0, 0, 0.05),0px 8px 16px 0px rgba(0, 0, 0, 0.1),0px 2px 4px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-default": "0px 0px 0px 1px rgba(0, 0, 0, 0.05),0px 8px 16px 0px rgba(0, 0, 0, 0.1),0px 2px 4px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-hovered": "0px 0px 0px 1px rgba(0, 0, 0, 0.05),0px 8px 16px 0px rgba(0, 0, 0, 0.1),0px 2px 4px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-disabled": "0px 0px 0px 1px rgba(0, 0, 0, 0.05),0px 8px 16px 0px rgba(0, 0, 0, 0.1),0px 2px 4px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-action-brand-primary-default": "0px 0px 0px 1px rgba(0, 0, 0, 0.05),0px 8px 16px 0px rgba(0, 0, 0, 0.1),0px 2px 4px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-action-brand-primary-hovered": "0px 0px 0px 1px rgba(0, 0, 0, 0.05),0px 8px 16px 0px rgba(0, 0, 0, 0.1),0px 2px 4px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-action-brand-primary-disabled": "0px 0px 0px 1px rgba(0, 0, 0, 0.05),0px 8px 16px 0px rgba(0, 0, 0, 0.1),0px 2px 4px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-floating-default": "0px 2px 6px 0px rgba(0, 0, 0, 0.1),0px 8px 16px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-formbox-default": "inset 0px 0px 0px 1px rgba(0, 0, 0, 0.05),inset 0px 1px 4px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-formbox-hovered": "inset 0px 0px 0px 1px rgba(0, 0, 0, 0.05),inset 0px 1px 4px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-checkbox-true-default": "inset 0px 0px 0px 1px rgba(0, 0, 0, 0.05),inset 0px 1px 4px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-checkbox-false-default": "inset 0px 0px 0px 1px rgba(0, 0, 0, 0.05),inset 0px 1px 4px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-radio-true-default": "inset 0px 0px 0px 1px rgba(0, 0, 0, 0.05),inset 0px 1px 4px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-radio-false-default": "inset 0px 0px 0px 1px rgba(0, 0, 0, 0.05),inset 0px 1px 4px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-color-border-basic-secondary": "rgba(0, 0, 0, 0.09)",
    "--sjs2-color-component-input-default-line": "rgba(0, 0, 0, 0.16)",
    "--sjs2-color-border-basic-secondary-overlay": "rgba(0, 0, 0, 0.16)",
    "--sjs2-color-bg-alert-primary": "rgba(229, 10, 62, 1)",
    "--sjs2-color-bg-alert-secondary": "rgba(229, 10, 62, 0.1)",
    "--sjs2-color-fg-alert-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-positive-primary": "rgba(25, 179, 148, 1)",
    "--sjs2-color-bg-positive-secondary": "rgba(25, 179, 148, 0.1)",
    "--sjs2-color-fg-positive-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-note-primary": "rgba(67, 127, 217, 1)",
    "--sjs2-color-bg-note-secondary": "rgba(67, 127, 217, 0.1)",
    "--sjs2-color-fg-note-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-warning-primary": "rgba(255, 152, 20, 1)",
    "--sjs2-color-bg-warning-secondary": "rgba(255, 152, 20, 0.1)",
    "--sjs2-color-fg-warning-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-radius-component-panel": "4px",
    "--sjs2-radius-component-formbox": "4px",
    "--sjs2-radius-component-action": "4px"
  }
};

export const LayeredDark = {
  "themeName": "layered",
  "colorPalette": "dark",
  "cssVariables": {
    "--sjs-general-dim-forecolor": "rgba(213, 215, 238, 1)",
    "--sjs-general-dim-forecolor-light": "rgba(117, 119, 141, 1)",
    "--sjs-secondary-backcolor": "rgba(255, 152, 20, 1)",
    "--sjs-secondary-backcolor-light": "rgba(255, 152, 20, 0.1)",
    "--sjs-secondary-backcolor-semi-light": "rgba(255, 152, 20, 0.25)",
    "--sjs-secondary-forecolor": "rgba(48, 48, 48, 1)",
    "--sjs-secondary-forecolor-light": "rgba(48, 48, 48, 0.25)",
    "--sjs-shadow-small-reset": "0px 0px 0px 0px rgba(255, 255, 255, 0.1),0px 0px 0px 0px rgba(0, 0, 0, 0.15),0px 0px 0px 0px rgba(0, 0, 0, 0.2)",
    "--sjs-shadow-inner-reset": "0px 0px 0px 0px rgba(255, 255, 255, 0.03),inset 0px 0px 0px 0px rgba(0, 0, 0, 0.2)",
    "--sjs-article-font-xx-large-textDecoration": "none",
    "--sjs-article-font-xx-large-fontWeight": "700",
    "--sjs-article-font-xx-large-fontStyle": "normal",
    "--sjs-article-font-xx-large-fontStretch": "normal",
    "--sjs-article-font-xx-large-letterSpacing": "0",
    "--sjs-article-font-xx-large-lineHeight": "64px",
    "--sjs-article-font-xx-large-paragraphIndent": "0px",
    "--sjs-article-font-xx-large-textCase": "none",
    "--sjs-article-font-x-large-textDecoration": "none",
    "--sjs-article-font-x-large-fontWeight": "700",
    "--sjs-article-font-x-large-fontStyle": "normal",
    "--sjs-article-font-x-large-fontStretch": "normal",
    "--sjs-article-font-x-large-letterSpacing": "0",
    "--sjs-article-font-x-large-lineHeight": "56px",
    "--sjs-article-font-x-large-paragraphIndent": "0px",
    "--sjs-article-font-x-large-textCase": "none",
    "--sjs-article-font-large-textDecoration": "none",
    "--sjs-article-font-large-fontWeight": "700",
    "--sjs-article-font-large-fontStyle": "normal",
    "--sjs-article-font-large-fontStretch": "normal",
    "--sjs-article-font-large-letterSpacing": "0",
    "--sjs-article-font-large-lineHeight": "40px",
    "--sjs-article-font-large-paragraphIndent": "0px",
    "--sjs-article-font-large-textCase": "none",
    "--sjs-article-font-medium-textDecoration": "none",
    "--sjs-article-font-medium-fontWeight": "700",
    "--sjs-article-font-medium-fontStyle": "normal",
    "--sjs-article-font-medium-fontStretch": "normal",
    "--sjs-article-font-medium-letterSpacing": "0",
    "--sjs-article-font-medium-lineHeight": "32px",
    "--sjs-article-font-medium-paragraphIndent": "0px",
    "--sjs-article-font-medium-textCase": "none",
    "--sjs-article-font-default-textDecoration": "none",
    "--sjs-article-font-default-fontWeight": "400",
    "--sjs-article-font-default-fontStyle": "normal",
    "--sjs-article-font-default-fontStretch": "normal",
    "--sjs-article-font-default-letterSpacing": "0",
    "--sjs-article-font-default-lineHeight": "28px",
    "--sjs-article-font-default-paragraphIndent": "0px",
    "--sjs-article-font-default-textCase": "none",
    "--sjs2-color-component-action-brand-tertiary-surface-default-bg": "rgba(39, 40, 50, 1)",
    "--sjs2-color-component-action-brand-tertiary-surface-hovered-bg": "rgba(46, 47, 58, 1)",
    "--sjs2-color-bg-basic-primary": "rgba(39, 40, 50, 1)",
    "--sjs2-color-utility-property-grid": "rgba(39, 40, 50, 1)",
    "--sjs2-color-utility-tabs": "rgba(39, 40, 50, 1)",
    "--sjs2-color-utility-toolbox": "rgba(39, 40, 50, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-default-bg": "rgba(39, 40, 50, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-hovered-bg": "rgba(39, 40, 50, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-default-bg": "rgba(39, 40, 50, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-hovered-bg": "rgba(39, 40, 50, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-default-bg": "rgba(39, 40, 50, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-hovered-bg": "rgba(39, 40, 50, 1)",
    "--sjs2-color-bg-basic-primary-dim": "rgba(46, 47, 58, 1)",
    "--sjs2-color-bg-neutral-tertiary-dim": "rgba(30, 31, 40, 1)",
    "--sjs2-color-utility-sheet": "rgba(30, 31, 40, 1)",
    "--sjs2-color-utility-surface-survey": "rgba(30, 31, 40, 1)",
    "--sjs2-color-bg-basic-secondary": "rgba(32, 33, 43, 1)",
    "--sjs2-color-bg-basic-secondary-dim": "rgba(37, 38, 48, 1)",
    "--sjs2-color-fg-basic-primary": "rgba(213, 215, 238, 1)",
    "--sjs2-color-fg-basic-secondary": "rgba(117, 120, 140, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-default-icon": "rgba(117, 120, 140, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-default-icon": "rgba(117, 120, 140, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-default-icon": "rgba(117, 120, 140, 1)",
    "--sjs2-color-project-brand-600": "rgba(164, 127, 243, 1)",
    "--sjs2-color-component-tagbox-item-default-bg": "rgba(164, 127, 243, 1)",
    "--sjs2-color-component-tagbox-item-hovered-bg": "rgba(164, 127, 243, 1)",
    "--sjs2-color-bg-brand-secondary": "rgba(164, 127, 243, 0.1)",
    "--sjs2-color-bg-brand-primary-dim": "rgba(192, 165, 251, 1)",
    "--sjs2-color-fg-brand-on-primary": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-default-label": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-hovered-label": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-action-hovered-icon": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-action-pressed-icon": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-action-default-icon": "rgba(32, 32, 32, 1)",
    "--sjs2-color-fg-brand-primary-disabled": "rgba(32, 32, 32, 0.25)",
    "--sjs2-color-component-tagbox-item-action-hovered-bg": "rgba(32, 32, 32, 0.25)",
    "--sjs2-base-unit-size": "8px",
    "--sjs2-base-unit-spacing": "8px",
    "--sjs2-base-unit-radius": "4px",
    "--sjs2-border-effect-surface-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.1),0px 8px 16px 0px rgba(0, 0, 0, 0.15),0px 2px 4px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-panel-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.1),0px 8px 16px 0px rgba(0, 0, 0, 0.15),0px 2px 4px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.1),0px 8px 16px 0px rgba(0, 0, 0, 0.15),0px 2px 4px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-hovered": "0px 0px 0px 1px rgba(255, 255, 255, 0.1),0px 8px 16px 0px rgba(0, 0, 0, 0.15),0px 2px 4px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-disabled": "0px 0px 0px 1px rgba(255, 255, 255, 0.1),0px 8px 16px 0px rgba(0, 0, 0, 0.15),0px 2px 4px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-primary-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.1),0px 8px 16px 0px rgba(0, 0, 0, 0.15),0px 2px 4px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-primary-hovered": "0px 0px 0px 1px rgba(255, 255, 255, 0.1),0px 8px 16px 0px rgba(0, 0, 0, 0.15),0px 2px 4px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-primary-disabled": "0px 0px 0px 1px rgba(255, 255, 255, 0.1),0px 8px 16px 0px rgba(0, 0, 0, 0.15),0px 2px 4px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-floating-default": "inset 0px 0px 0px 1px rgba(255, 255, 255, 0.05),0px 2px 6px 0px rgba(0, 0, 0, 0.2),0px 8px 16px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-formbox-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.03),inset 0px 1px 4px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-formbox-hovered": "0px 0px 0px 1px rgba(255, 255, 255, 0.03),inset 0px 1px 4px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-checkbox-true-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.03),inset 0px 1px 4px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-checkbox-false-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.03),inset 0px 1px 4px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-radio-true-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.03),inset 0px 1px 4px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-radio-false-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.03),inset 0px 1px 4px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-color-border-basic-secondary": "rgba(54, 56, 69, 1)",
    "--sjs2-color-component-input-default-line": "rgba(67, 69, 85, 1)",
    "--sjs2-color-border-basic-secondary-overlay": "rgba(255, 255, 255, 0.08)",
    "--sjs2-color-bg-alert-primary": "rgba(254, 76, 108, 1)",
    "--sjs2-color-bg-alert-secondary": "rgba(254, 76, 108, 0.1)",
    "--sjs2-color-fg-alert-on-primary": "rgba(48, 48, 48, 1)",
    "--sjs2-color-bg-positive-primary": "rgba(36, 197, 164, 1)",
    "--sjs2-color-bg-positive-secondary": "rgba(36, 197, 164, 0.1)",
    "--sjs2-color-fg-positive-on-primary": "rgba(48, 48, 48, 1)",
    "--sjs2-color-bg-note-primary": "rgba(91, 151, 242, 1)",
    "--sjs2-color-bg-note-secondary": "rgba(91, 151, 242, 0.1)",
    "--sjs2-color-fg-note-on-primary": "rgba(48, 48, 48, 1)",
    "--sjs2-color-bg-warning-primary": "rgba(255, 152, 20, 1)",
    "--sjs2-color-bg-warning-secondary": "rgba(255, 152, 20, 0.1)",
    "--sjs2-color-fg-warning-on-primary": "rgba(48, 48, 48, 1)",
    "--sjs2-radius-component-panel": "4px",
    "--sjs2-radius-component-formbox": "4px",
    "--sjs2-radius-component-action": "4px"
  }
};

export const LayeredLightPanelless = {
  "themeName": "layered",
  "colorPalette": "light",
  "isPanelless": true,
  "cssVariables": {
    "--sjs-general-dim-forecolor": "rgba(0, 0, 0, 0.91)",
    "--sjs-general-dim-forecolor-light": "rgba(0, 0, 0, 0.5)",
    "--sjs-secondary-backcolor": "rgba(255, 152, 20, 1)",
    "--sjs-secondary-backcolor-light": "rgba(255, 152, 20, 0.1)",
    "--sjs-secondary-backcolor-semi-light": "rgba(255, 152, 20, 0.25)",
    "--sjs-secondary-forecolor": "rgba(255, 255, 255, 1)",
    "--sjs-secondary-forecolor-light": "rgba(255, 255, 255, 0.25)",
    "--sjs-shadow-small-reset": "0px 0px 0px 0px rgba(0, 0, 0, 0.05),0px 0px 0px 0px rgba(0, 0, 0, 0.1),0px 0px 0px 0px rgba(0, 0, 0, 0.1)",
    "--sjs-shadow-inner-reset": "inset 0px 0px 0px 0px rgba(0, 0, 0, 0.05),inset 0px 0px 0px 0px rgba(0, 0, 0, 0.1)",
    "--sjs-article-font-xx-large-textDecoration": "none",
    "--sjs-article-font-xx-large-fontWeight": "700",
    "--sjs-article-font-xx-large-fontStyle": "normal",
    "--sjs-article-font-xx-large-fontStretch": "normal",
    "--sjs-article-font-xx-large-letterSpacing": "0",
    "--sjs-article-font-xx-large-lineHeight": "64px",
    "--sjs-article-font-xx-large-paragraphIndent": "0px",
    "--sjs-article-font-xx-large-textCase": "none",
    "--sjs-article-font-x-large-textDecoration": "none",
    "--sjs-article-font-x-large-fontWeight": "700",
    "--sjs-article-font-x-large-fontStyle": "normal",
    "--sjs-article-font-x-large-fontStretch": "normal",
    "--sjs-article-font-x-large-letterSpacing": "0",
    "--sjs-article-font-x-large-lineHeight": "56px",
    "--sjs-article-font-x-large-paragraphIndent": "0px",
    "--sjs-article-font-x-large-textCase": "none",
    "--sjs-article-font-large-textDecoration": "none",
    "--sjs-article-font-large-fontWeight": "700",
    "--sjs-article-font-large-fontStyle": "normal",
    "--sjs-article-font-large-fontStretch": "normal",
    "--sjs-article-font-large-letterSpacing": "0",
    "--sjs-article-font-large-lineHeight": "40px",
    "--sjs-article-font-large-paragraphIndent": "0px",
    "--sjs-article-font-large-textCase": "none",
    "--sjs-article-font-medium-textDecoration": "none",
    "--sjs-article-font-medium-fontWeight": "700",
    "--sjs-article-font-medium-fontStyle": "normal",
    "--sjs-article-font-medium-fontStretch": "normal",
    "--sjs-article-font-medium-letterSpacing": "0",
    "--sjs-article-font-medium-lineHeight": "32px",
    "--sjs-article-font-medium-paragraphIndent": "0px",
    "--sjs-article-font-medium-textCase": "none",
    "--sjs-article-font-default-textDecoration": "none",
    "--sjs-article-font-default-fontWeight": "400",
    "--sjs-article-font-default-fontStyle": "normal",
    "--sjs-article-font-default-fontStretch": "normal",
    "--sjs-article-font-default-letterSpacing": "0",
    "--sjs-article-font-default-lineHeight": "28px",
    "--sjs-article-font-default-paragraphIndent": "0px",
    "--sjs-article-font-default-textCase": "none",
    "--sjs2-color-component-action-brand-tertiary-surface-default-bg": "rgba(241, 237, 248, 1)",
    "--sjs2-color-component-action-brand-tertiary-surface-hovered-bg": "rgba(225, 220, 233, 1)",
    "--sjs2-layout-component-page-content-area-gap-horizontal": "var(--sjs2-spacing-large-horizontal)",
    "--sjs2-layout-component-page-content-area-gap-vertical": "var(--sjs2-spacing-large-vertical)",
    "--sjs2-layout-component-panel-simple-box-gap-vertical": "var(--sjs2-spacing-medium-vertical)",
    "--sjs2-layout-component-panel-simple-content-area-padding-horizontal": "var(--sjs2-spacing-x000)",
    "--sjs2-layout-component-panel-simple-content-area-padding-top": "var(--sjs2-spacing-x000)",
    "--sjs2-layout-component-panel-simple-content-area-padding-bottom": "var(--sjs2-spacing-x000)",
    "--sjs2-layout-component-panel-simple-content-area-gap-horizontal": "var(--sjs2-spacing-x500)",
    "--sjs2-layout-component-panel-simple-nested-content-area-gap-horizontal": "var(--sjs2-spacing-x500)",
    "--sjs2-radius-component-panel-simple": "var(--sjs2-radius-x000)",
    "--sjs2-is-panelless": "true",
    "--sjs2-color-utility-surface-survey": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-panel-simple-default-bg": "transparent",
    "--sjs2-color-component-panel-simple-default-border": "transparent",
    "--sjs2-color-component-panel-default-bg": "transparent",
    "--sjs2-color-bg-basic-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-utility-property-grid": "rgba(255, 255, 255, 1)",
    "--sjs2-color-utility-tabs": "rgba(255, 255, 255, 1)",
    "--sjs2-color-utility-toolbox": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-default-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-hovered-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-default-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-hovered-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-default-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-hovered-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-basic-primary-dim": "rgba(244, 244, 244, 1)",
    "--sjs2-color-bg-neutral-tertiary-dim": "rgba(255, 255, 255, 1)",
    "--sjs2-color-utility-sheet": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-basic-secondary": "rgba(241, 237, 248, 1)",
    "--sjs2-color-bg-basic-secondary-dim": "rgba(225, 220, 233, 1)",
    "--sjs2-color-fg-basic-primary": "rgba(0, 0, 0, 0.91)",
    "--sjs2-color-fg-basic-secondary": "rgba(0, 0, 0, 0.45)",
    "--sjs2-color-component-action-alert-quaternary-surface-default-icon": "rgba(0, 0, 0, 0.45)",
    "--sjs2-color-component-action-brand-quaternary-surface-default-icon": "rgba(0, 0, 0, 0.45)",
    "--sjs2-color-component-action-neutral-quaternary-surface-default-icon": "rgba(0, 0, 0, 0.45)",
    "--sjs2-color-project-brand-600": "rgba(122, 100, 168, 1)",
    "--sjs2-color-component-tagbox-item-default-bg": "rgba(122, 100, 168, 1)",
    "--sjs2-color-component-tagbox-item-hovered-bg": "rgba(122, 100, 168, 1)",
    "--sjs2-color-bg-brand-secondary": "rgba(122, 100, 168, 0.1)",
    "--sjs2-color-bg-brand-primary-dim": "rgba(105, 84, 152, 1)",
    "--sjs2-color-fg-brand-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-default-label": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-hovered-label": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-action-hovered-icon": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-action-pressed-icon": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-action-default-icon": "rgba(255, 255, 255, 1)",
    "--sjs2-color-fg-brand-primary-disabled": "rgba(255, 255, 255, 0.25)",
    "--sjs2-color-component-tagbox-item-action-hovered-bg": "rgba(255, 255, 255, 0.25)",
    "--sjs2-base-unit-size": "8px",
    "--sjs2-base-unit-spacing": "8px",
    "--sjs2-base-unit-radius": "4px",
    "--sjs2-border-effect-surface-default": "0px 0px 0px 1px rgba(0, 0, 0, 0.05),0px 8px 16px 0px rgba(0, 0, 0, 0.1),0px 2px 4px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-panel-default": "0px 0px 0px 1px rgba(0, 0, 0, 0.05),0px 8px 16px 0px rgba(0, 0, 0, 0.1),0px 2px 4px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-default": "0px 0px 0px 1px rgba(0, 0, 0, 0.05),0px 8px 16px 0px rgba(0, 0, 0, 0.1),0px 2px 4px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-hovered": "0px 0px 0px 1px rgba(0, 0, 0, 0.05),0px 8px 16px 0px rgba(0, 0, 0, 0.1),0px 2px 4px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-disabled": "0px 0px 0px 1px rgba(0, 0, 0, 0.05),0px 8px 16px 0px rgba(0, 0, 0, 0.1),0px 2px 4px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-action-brand-primary-default": "0px 0px 0px 1px rgba(0, 0, 0, 0.05),0px 8px 16px 0px rgba(0, 0, 0, 0.1),0px 2px 4px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-action-brand-primary-hovered": "0px 0px 0px 1px rgba(0, 0, 0, 0.05),0px 8px 16px 0px rgba(0, 0, 0, 0.1),0px 2px 4px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-action-brand-primary-disabled": "0px 0px 0px 1px rgba(0, 0, 0, 0.05),0px 8px 16px 0px rgba(0, 0, 0, 0.1),0px 2px 4px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-floating-default": "0px 2px 6px 0px rgba(0, 0, 0, 0.1),0px 8px 16px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-formbox-default": "inset 0px 0px 0px 1px rgba(0, 0, 0, 0.05),inset 0px 1px 4px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-formbox-hovered": "inset 0px 0px 0px 1px rgba(0, 0, 0, 0.05),inset 0px 1px 4px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-checkbox-true-default": "inset 0px 0px 0px 1px rgba(0, 0, 0, 0.05),inset 0px 1px 4px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-checkbox-false-default": "inset 0px 0px 0px 1px rgba(0, 0, 0, 0.05),inset 0px 1px 4px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-radio-true-default": "inset 0px 0px 0px 1px rgba(0, 0, 0, 0.05),inset 0px 1px 4px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-radio-false-default": "inset 0px 0px 0px 1px rgba(0, 0, 0, 0.05),inset 0px 1px 4px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-color-border-basic-secondary": "rgba(0, 0, 0, 0.09)",
    "--sjs2-color-component-input-default-line": "rgba(0, 0, 0, 0.16)",
    "--sjs2-color-border-basic-secondary-overlay": "rgba(0, 0, 0, 0.16)",
    "--sjs2-color-bg-alert-primary": "rgba(229, 10, 62, 1)",
    "--sjs2-color-bg-alert-secondary": "rgba(229, 10, 62, 0.1)",
    "--sjs2-color-fg-alert-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-positive-primary": "rgba(25, 179, 148, 1)",
    "--sjs2-color-bg-positive-secondary": "rgba(25, 179, 148, 0.1)",
    "--sjs2-color-fg-positive-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-note-primary": "rgba(67, 127, 217, 1)",
    "--sjs2-color-bg-note-secondary": "rgba(67, 127, 217, 0.1)",
    "--sjs2-color-fg-note-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-warning-primary": "rgba(255, 152, 20, 1)",
    "--sjs2-color-bg-warning-secondary": "rgba(255, 152, 20, 0.1)",
    "--sjs2-color-fg-warning-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-radius-component-panel": "4px",
    "--sjs2-radius-component-formbox": "4px",
    "--sjs2-radius-component-action": "4px"
  }
};

export const LayeredDarkPanelless = {
  "themeName": "layered",
  "colorPalette": "dark",
  "isPanelless": true,
  "cssVariables": {
    "--sjs-general-dim-forecolor": "rgba(213, 215, 238, 1)",
    "--sjs-general-dim-forecolor-light": "rgba(117, 119, 141, 1)",
    "--sjs-secondary-backcolor": "rgba(255, 152, 20, 1)",
    "--sjs-secondary-backcolor-light": "rgba(255, 152, 20, 0.1)",
    "--sjs-secondary-backcolor-semi-light": "rgba(255, 152, 20, 0.25)",
    "--sjs-secondary-forecolor": "rgba(48, 48, 48, 1)",
    "--sjs-secondary-forecolor-light": "rgba(48, 48, 48, 0.25)",
    "--sjs-shadow-small-reset": "0px 0px 0px 0px rgba(255, 255, 255, 0.1),0px 0px 0px 0px rgba(0, 0, 0, 0.15),0px 0px 0px 0px rgba(0, 0, 0, 0.2)",
    "--sjs-shadow-inner-reset": "0px 0px 0px 0px rgba(255, 255, 255, 0.03),inset 0px 0px 0px 0px rgba(0, 0, 0, 0.2)",
    "--sjs-article-font-xx-large-textDecoration": "none",
    "--sjs-article-font-xx-large-fontWeight": "700",
    "--sjs-article-font-xx-large-fontStyle": "normal",
    "--sjs-article-font-xx-large-fontStretch": "normal",
    "--sjs-article-font-xx-large-letterSpacing": "0",
    "--sjs-article-font-xx-large-lineHeight": "64px",
    "--sjs-article-font-xx-large-paragraphIndent": "0px",
    "--sjs-article-font-xx-large-textCase": "none",
    "--sjs-article-font-x-large-textDecoration": "none",
    "--sjs-article-font-x-large-fontWeight": "700",
    "--sjs-article-font-x-large-fontStyle": "normal",
    "--sjs-article-font-x-large-fontStretch": "normal",
    "--sjs-article-font-x-large-letterSpacing": "0",
    "--sjs-article-font-x-large-lineHeight": "56px",
    "--sjs-article-font-x-large-paragraphIndent": "0px",
    "--sjs-article-font-x-large-textCase": "none",
    "--sjs-article-font-large-textDecoration": "none",
    "--sjs-article-font-large-fontWeight": "700",
    "--sjs-article-font-large-fontStyle": "normal",
    "--sjs-article-font-large-fontStretch": "normal",
    "--sjs-article-font-large-letterSpacing": "0",
    "--sjs-article-font-large-lineHeight": "40px",
    "--sjs-article-font-large-paragraphIndent": "0px",
    "--sjs-article-font-large-textCase": "none",
    "--sjs-article-font-medium-textDecoration": "none",
    "--sjs-article-font-medium-fontWeight": "700",
    "--sjs-article-font-medium-fontStyle": "normal",
    "--sjs-article-font-medium-fontStretch": "normal",
    "--sjs-article-font-medium-letterSpacing": "0",
    "--sjs-article-font-medium-lineHeight": "32px",
    "--sjs-article-font-medium-paragraphIndent": "0px",
    "--sjs-article-font-medium-textCase": "none",
    "--sjs-article-font-default-textDecoration": "none",
    "--sjs-article-font-default-fontWeight": "400",
    "--sjs-article-font-default-fontStyle": "normal",
    "--sjs-article-font-default-fontStretch": "normal",
    "--sjs-article-font-default-letterSpacing": "0",
    "--sjs-article-font-default-lineHeight": "28px",
    "--sjs-article-font-default-paragraphIndent": "0px",
    "--sjs-article-font-default-textCase": "none",
    "--sjs2-color-component-action-brand-tertiary-surface-default-bg": "rgba(32, 33, 43, 1)",
    "--sjs2-color-component-action-brand-tertiary-surface-hovered-bg": "rgba(37, 38, 48, 1)",
    "--sjs2-layout-component-page-content-area-gap-horizontal": "var(--sjs2-spacing-large-horizontal)",
    "--sjs2-layout-component-page-content-area-gap-vertical": "var(--sjs2-spacing-large-vertical)",
    "--sjs2-layout-component-panel-simple-box-gap-vertical": "var(--sjs2-spacing-medium-vertical)",
    "--sjs2-layout-component-panel-simple-content-area-padding-horizontal": "var(--sjs2-spacing-x000)",
    "--sjs2-layout-component-panel-simple-content-area-padding-top": "var(--sjs2-spacing-x000)",
    "--sjs2-layout-component-panel-simple-content-area-padding-bottom": "var(--sjs2-spacing-x000)",
    "--sjs2-layout-component-panel-simple-content-area-gap-horizontal": "var(--sjs2-spacing-x500)",
    "--sjs2-layout-component-panel-simple-nested-content-area-gap-horizontal": "var(--sjs2-spacing-x500)",
    "--sjs2-radius-component-panel-simple": "var(--sjs2-radius-x000)",
    "--sjs2-is-panelless": "true",
    "--sjs2-color-utility-surface-survey": "rgba(39, 40, 50, 1)",
    "--sjs2-color-component-panel-simple-default-bg": "transparent",
    "--sjs2-color-component-panel-simple-default-border": "transparent",
    "--sjs2-color-component-panel-default-bg": "transparent",
    "--sjs2-color-bg-basic-primary": "rgba(39, 40, 50, 1)",
    "--sjs2-color-utility-property-grid": "rgba(39, 40, 50, 1)",
    "--sjs2-color-utility-tabs": "rgba(39, 40, 50, 1)",
    "--sjs2-color-utility-toolbox": "rgba(39, 40, 50, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-default-bg": "rgba(39, 40, 50, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-hovered-bg": "rgba(39, 40, 50, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-default-bg": "rgba(39, 40, 50, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-hovered-bg": "rgba(39, 40, 50, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-default-bg": "rgba(39, 40, 50, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-hovered-bg": "rgba(39, 40, 50, 1)",
    "--sjs2-color-bg-basic-primary-dim": "rgba(46, 47, 58, 1)",
    "--sjs2-color-bg-neutral-tertiary-dim": "rgba(39, 40, 50, 1)",
    "--sjs2-color-utility-sheet": "rgba(39, 40, 50, 1)",
    "--sjs2-color-bg-basic-secondary": "rgba(32, 33, 43, 1)",
    "--sjs2-color-bg-basic-secondary-dim": "rgba(37, 38, 48, 1)",
    "--sjs2-color-fg-basic-primary": "rgba(213, 215, 238, 1)",
    "--sjs2-color-fg-basic-secondary": "rgba(117, 120, 140, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-default-icon": "rgba(117, 120, 140, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-default-icon": "rgba(117, 120, 140, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-default-icon": "rgba(117, 120, 140, 1)",
    "--sjs2-color-project-brand-600": "rgba(164, 127, 243, 1)",
    "--sjs2-color-component-tagbox-item-default-bg": "rgba(164, 127, 243, 1)",
    "--sjs2-color-component-tagbox-item-hovered-bg": "rgba(164, 127, 243, 1)",
    "--sjs2-color-bg-brand-secondary": "rgba(164, 127, 243, 0.1)",
    "--sjs2-color-bg-brand-primary-dim": "rgba(192, 165, 251, 1)",
    "--sjs2-color-fg-brand-on-primary": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-default-label": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-hovered-label": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-action-hovered-icon": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-action-pressed-icon": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-action-default-icon": "rgba(32, 32, 32, 1)",
    "--sjs2-color-fg-brand-primary-disabled": "rgba(32, 32, 32, 0.25)",
    "--sjs2-color-component-tagbox-item-action-hovered-bg": "rgba(32, 32, 32, 0.25)",
    "--sjs2-base-unit-size": "8px",
    "--sjs2-base-unit-spacing": "8px",
    "--sjs2-base-unit-radius": "4px",
    "--sjs2-border-effect-surface-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.1),0px 8px 16px 0px rgba(0, 0, 0, 0.15),0px 2px 4px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-panel-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.1),0px 8px 16px 0px rgba(0, 0, 0, 0.15),0px 2px 4px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.1),0px 8px 16px 0px rgba(0, 0, 0, 0.15),0px 2px 4px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-hovered": "0px 0px 0px 1px rgba(255, 255, 255, 0.1),0px 8px 16px 0px rgba(0, 0, 0, 0.15),0px 2px 4px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-disabled": "0px 0px 0px 1px rgba(255, 255, 255, 0.1),0px 8px 16px 0px rgba(0, 0, 0, 0.15),0px 2px 4px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-primary-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.1),0px 8px 16px 0px rgba(0, 0, 0, 0.15),0px 2px 4px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-primary-hovered": "0px 0px 0px 1px rgba(255, 255, 255, 0.1),0px 8px 16px 0px rgba(0, 0, 0, 0.15),0px 2px 4px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-primary-disabled": "0px 0px 0px 1px rgba(255, 255, 255, 0.1),0px 8px 16px 0px rgba(0, 0, 0, 0.15),0px 2px 4px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-floating-default": "inset 0px 0px 0px 1px rgba(255, 255, 255, 0.05),0px 2px 6px 0px rgba(0, 0, 0, 0.2),0px 8px 16px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-formbox-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.03),inset 0px 1px 4px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-formbox-hovered": "0px 0px 0px 1px rgba(255, 255, 255, 0.03),inset 0px 1px 4px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-checkbox-true-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.03),inset 0px 1px 4px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-checkbox-false-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.03),inset 0px 1px 4px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-radio-true-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.03),inset 0px 1px 4px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-radio-false-default": "0px 0px 0px 1px rgba(255, 255, 255, 0.03),inset 0px 1px 4px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-color-border-basic-secondary": "rgba(54, 56, 69, 1)",
    "--sjs2-color-component-input-default-line": "rgba(67, 69, 85, 1)",
    "--sjs2-color-border-basic-secondary-overlay": "rgba(255, 255, 255, 0.08)",
    "--sjs2-color-bg-alert-primary": "rgba(254, 76, 108, 1)",
    "--sjs2-color-bg-alert-secondary": "rgba(254, 76, 108, 0.1)",
    "--sjs2-color-fg-alert-on-primary": "rgba(48, 48, 48, 1)",
    "--sjs2-color-bg-positive-primary": "rgba(36, 197, 164, 1)",
    "--sjs2-color-bg-positive-secondary": "rgba(36, 197, 164, 0.1)",
    "--sjs2-color-fg-positive-on-primary": "rgba(48, 48, 48, 1)",
    "--sjs2-color-bg-note-primary": "rgba(91, 151, 242, 1)",
    "--sjs2-color-bg-note-secondary": "rgba(91, 151, 242, 0.1)",
    "--sjs2-color-fg-note-on-primary": "rgba(48, 48, 48, 1)",
    "--sjs2-color-bg-warning-primary": "rgba(255, 152, 20, 1)",
    "--sjs2-color-bg-warning-secondary": "rgba(255, 152, 20, 0.1)",
    "--sjs2-color-fg-warning-on-primary": "rgba(48, 48, 48, 1)",
    "--sjs2-radius-component-panel": "4px",
    "--sjs2-radius-component-formbox": "4px",
    "--sjs2-radius-component-action": "4px"
  }
};

export const SolidLight = {
  "themeName": "solid",
  "colorPalette": "light",
  "cssVariables": {
    "--sjs-general-dim-forecolor": "rgba(255, 255, 255, 1)",
    "--sjs-general-dim-forecolor-light": "rgba(255, 255, 255, 0.8)",
    "--sjs-secondary-backcolor": "rgba(255, 152, 20, 1)",
    "--sjs-secondary-backcolor-light": "rgba(255, 152, 20, 0.1)",
    "--sjs-secondary-backcolor-semi-light": "rgba(255, 152, 20, 0.25)",
    "--sjs-secondary-forecolor": "rgba(255, 255, 255, 1)",
    "--sjs-secondary-forecolor-light": "rgba(255, 255, 255, 0.25)",
    "--sjs-shadow-small-reset": "0px 0px 0px 0px rgba(0, 0, 0, 0.2)",
    "--sjs-shadow-inner-reset": "inset 0px 0px 0px 0px rgba(0, 0, 0, 0.1)",
    "--sjs-article-font-xx-large-textDecoration": "none",
    "--sjs-article-font-xx-large-fontWeight": "700",
    "--sjs-article-font-xx-large-fontStyle": "normal",
    "--sjs-article-font-xx-large-fontStretch": "normal",
    "--sjs-article-font-xx-large-letterSpacing": "0",
    "--sjs-article-font-xx-large-lineHeight": "64px",
    "--sjs-article-font-xx-large-paragraphIndent": "0px",
    "--sjs-article-font-xx-large-textCase": "none",
    "--sjs-article-font-x-large-textDecoration": "none",
    "--sjs-article-font-x-large-fontWeight": "700",
    "--sjs-article-font-x-large-fontStyle": "normal",
    "--sjs-article-font-x-large-fontStretch": "normal",
    "--sjs-article-font-x-large-letterSpacing": "0",
    "--sjs-article-font-x-large-lineHeight": "56px",
    "--sjs-article-font-x-large-paragraphIndent": "0px",
    "--sjs-article-font-x-large-textCase": "none",
    "--sjs-article-font-large-textDecoration": "none",
    "--sjs-article-font-large-fontWeight": "700",
    "--sjs-article-font-large-fontStyle": "normal",
    "--sjs-article-font-large-fontStretch": "normal",
    "--sjs-article-font-large-letterSpacing": "0",
    "--sjs-article-font-large-lineHeight": "40px",
    "--sjs-article-font-large-paragraphIndent": "0px",
    "--sjs-article-font-large-textCase": "none",
    "--sjs-article-font-medium-textDecoration": "none",
    "--sjs-article-font-medium-fontWeight": "700",
    "--sjs-article-font-medium-fontStyle": "normal",
    "--sjs-article-font-medium-fontStretch": "normal",
    "--sjs-article-font-medium-letterSpacing": "0",
    "--sjs-article-font-medium-lineHeight": "32px",
    "--sjs-article-font-medium-paragraphIndent": "0px",
    "--sjs-article-font-medium-textCase": "none",
    "--sjs-article-font-default-textDecoration": "none",
    "--sjs-article-font-default-fontWeight": "400",
    "--sjs-article-font-default-fontStyle": "normal",
    "--sjs-article-font-default-fontStretch": "normal",
    "--sjs-article-font-default-letterSpacing": "0",
    "--sjs-article-font-default-lineHeight": "28px",
    "--sjs-article-font-default-paragraphIndent": "0px",
    "--sjs-article-font-default-textCase": "none",
    "--sjs2-color-component-action-brand-tertiary-surface-default-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-brand-tertiary-surface-hovered-bg": "rgba(243, 243, 243, 1)",
    "--sjs2-color-bg-basic-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-utility-property-grid": "rgba(255, 255, 255, 1)",
    "--sjs2-color-utility-tabs": "rgba(255, 255, 255, 1)",
    "--sjs2-color-utility-toolbox": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-default-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-hovered-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-default-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-hovered-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-default-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-hovered-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-basic-primary-dim": "rgba(243, 243, 243, 1)",
    "--sjs2-color-bg-neutral-tertiary-dim": "rgba(46, 172, 180, 1)",
    "--sjs2-color-utility-sheet": "rgba(46, 172, 180, 1)",
    "--sjs2-color-utility-surface-survey": "rgba(46, 172, 180, 1)",
    "--sjs2-color-bg-basic-secondary": "rgba(245, 245, 245, 1)",
    "--sjs2-color-bg-basic-secondary-dim": "rgba(234, 234, 234, 1)",
    "--sjs2-color-fg-basic-primary": "rgba(0, 0, 0, 0.91)",
    "--sjs2-color-fg-basic-secondary": "rgba(0, 0, 0, 0.43)",
    "--sjs2-color-component-action-alert-quaternary-surface-default-icon": "rgba(0, 0, 0, 0.43)",
    "--sjs2-color-component-action-brand-quaternary-surface-default-icon": "rgba(0, 0, 0, 0.43)",
    "--sjs2-color-component-action-neutral-quaternary-surface-default-icon": "rgba(0, 0, 0, 0.43)",
    "--sjs2-color-project-brand-600": "rgba(46, 172, 180, 1)",
    "--sjs2-color-component-tagbox-item-default-bg": "rgba(46, 172, 180, 1)",
    "--sjs2-color-component-tagbox-item-hovered-bg": "rgba(46, 172, 180, 1)",
    "--sjs2-color-bg-brand-secondary": "rgba(46, 172, 180, 0.1)",
    "--sjs2-color-bg-brand-primary-dim": "rgba(23, 156, 165, 1)",
    "--sjs2-color-fg-brand-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-default-label": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-hovered-label": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-action-hovered-icon": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-action-pressed-icon": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-action-default-icon": "rgba(255, 255, 255, 1)",
    "--sjs2-color-fg-brand-primary-disabled": "rgba(255, 255, 255, 0.25)",
    "--sjs2-color-component-tagbox-item-action-hovered-bg": "rgba(255, 255, 255, 0.25)",
    "--sjs2-base-unit-size": "8px",
    "--sjs2-base-unit-spacing": "8px",
    "--sjs2-base-unit-radius": "4px",
    "--sjs2-border-effect-surface-default": "0px 2px 0px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-panel-default": "0px 2px 0px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-default": "0px 2px 0px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-hovered": "0px 2px 0px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-disabled": "0px 2px 0px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-primary-default": "0px 2px 0px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-primary-hovered": "0px 2px 0px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-primary-disabled": "0px 2px 0px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-floating-default": "0px 2px 6px 0px rgba(0, 0, 0, 0.1),0px 8px 16px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-formbox-default": "inset 0px 2px 0px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-formbox-hovered": "inset 0px 2px 0px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-checkbox-true-default": "inset 0px 2px 0px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-checkbox-false-default": "inset 0px 2px 0px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-radio-true-default": "inset 0px 2px 0px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-radio-false-default": "inset 0px 2px 0px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-color-border-basic-secondary": "rgba(0, 0, 0, 0.09)",
    "--sjs2-color-component-input-default-line": "rgba(0, 0, 0, 0.16)",
    "--sjs2-color-border-basic-secondary-overlay": "rgba(0, 0, 0, 0.16)",
    "--sjs2-color-bg-alert-primary": "rgba(229, 10, 62, 1)",
    "--sjs2-color-bg-alert-secondary": "rgba(229, 10, 62, 0.1)",
    "--sjs2-color-fg-alert-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-positive-primary": "rgba(25, 179, 148, 1)",
    "--sjs2-color-bg-positive-secondary": "rgba(25, 179, 148, 0.1)",
    "--sjs2-color-fg-positive-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-note-primary": "rgba(67, 127, 217, 1)",
    "--sjs2-color-bg-note-secondary": "rgba(67, 127, 217, 0.1)",
    "--sjs2-color-fg-note-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-warning-primary": "rgba(255, 152, 20, 1)",
    "--sjs2-color-bg-warning-secondary": "rgba(255, 152, 20, 0.1)",
    "--sjs2-color-fg-warning-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-radius-component-panel": "4px",
    "--sjs2-radius-component-formbox": "4px",
    "--sjs2-radius-component-action": "4px"
  }
};

export const SolidDark = {
  "themeName": "solid",
  "colorPalette": "dark",
  "cssVariables": {
    "--sjs-general-dim-forecolor": "rgba(255, 255, 255, 0.79)",
    "--sjs-general-dim-forecolor-light": "rgba(125, 130, 148, 1)",
    "--sjs-secondary-backcolor": "rgba(255, 152, 20, 1)",
    "--sjs-secondary-backcolor-light": "rgba(255, 152, 20, 0.1)",
    "--sjs-secondary-backcolor-semi-light": "rgba(255, 152, 20, 0.25)",
    "--sjs-secondary-forecolor": "rgba(48, 48, 48, 1)",
    "--sjs-secondary-forecolor-light": "rgba(48, 48, 48, 0.25)",
    "--sjs-shadow-small-reset": "0px 0px 0px 0px rgba(33, 35, 43, 1)",
    "--sjs-shadow-inner-reset": "0px 0px 0px 0px rgba(33, 35, 43, 1)",
    "--sjs-article-font-xx-large-textDecoration": "none",
    "--sjs-article-font-xx-large-fontWeight": "700",
    "--sjs-article-font-xx-large-fontStyle": "normal",
    "--sjs-article-font-xx-large-fontStretch": "normal",
    "--sjs-article-font-xx-large-letterSpacing": "0",
    "--sjs-article-font-xx-large-lineHeight": "64px",
    "--sjs-article-font-xx-large-paragraphIndent": "0px",
    "--sjs-article-font-xx-large-textCase": "none",
    "--sjs-article-font-x-large-textDecoration": "none",
    "--sjs-article-font-x-large-fontWeight": "700",
    "--sjs-article-font-x-large-fontStyle": "normal",
    "--sjs-article-font-x-large-fontStretch": "normal",
    "--sjs-article-font-x-large-letterSpacing": "0",
    "--sjs-article-font-x-large-lineHeight": "56px",
    "--sjs-article-font-x-large-paragraphIndent": "0px",
    "--sjs-article-font-x-large-textCase": "none",
    "--sjs-article-font-large-textDecoration": "none",
    "--sjs-article-font-large-fontWeight": "700",
    "--sjs-article-font-large-fontStyle": "normal",
    "--sjs-article-font-large-fontStretch": "normal",
    "--sjs-article-font-large-letterSpacing": "0",
    "--sjs-article-font-large-lineHeight": "40px",
    "--sjs-article-font-large-paragraphIndent": "0px",
    "--sjs-article-font-large-textCase": "none",
    "--sjs-article-font-medium-textDecoration": "none",
    "--sjs-article-font-medium-fontWeight": "700",
    "--sjs-article-font-medium-fontStyle": "normal",
    "--sjs-article-font-medium-fontStretch": "normal",
    "--sjs-article-font-medium-letterSpacing": "0",
    "--sjs-article-font-medium-lineHeight": "32px",
    "--sjs-article-font-medium-paragraphIndent": "0px",
    "--sjs-article-font-medium-textCase": "none",
    "--sjs-article-font-default-textDecoration": "none",
    "--sjs-article-font-default-fontWeight": "400",
    "--sjs-article-font-default-fontStyle": "normal",
    "--sjs-article-font-default-fontStretch": "normal",
    "--sjs-article-font-default-letterSpacing": "0",
    "--sjs-article-font-default-lineHeight": "28px",
    "--sjs-article-font-default-paragraphIndent": "0px",
    "--sjs-article-font-default-textCase": "none",
    "--sjs2-color-component-action-brand-tertiary-surface-default-bg": "rgba(53, 55, 63, 1)",
    "--sjs2-color-component-action-brand-tertiary-surface-hovered-bg": "rgba(60, 63, 74, 1)",
    "--sjs2-color-bg-basic-primary": "rgba(53, 55, 63, 1)",
    "--sjs2-color-utility-property-grid": "rgba(53, 55, 63, 1)",
    "--sjs2-color-utility-tabs": "rgba(53, 55, 63, 1)",
    "--sjs2-color-utility-toolbox": "rgba(53, 55, 63, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-default-bg": "rgba(53, 55, 63, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-hovered-bg": "rgba(53, 55, 63, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-default-bg": "rgba(53, 55, 63, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-hovered-bg": "rgba(53, 55, 63, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-default-bg": "rgba(53, 55, 63, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-hovered-bg": "rgba(53, 55, 63, 1)",
    "--sjs2-color-bg-basic-primary-dim": "rgba(60, 63, 74, 1)",
    "--sjs2-color-bg-neutral-tertiary-dim": "rgba(38, 40, 47, 1)",
    "--sjs2-color-utility-sheet": "rgba(38, 40, 47, 1)",
    "--sjs2-color-utility-surface-survey": "rgba(38, 40, 47, 1)",
    "--sjs2-color-bg-basic-secondary": "rgba(46, 48, 55, 1)",
    "--sjs2-color-bg-basic-secondary-dim": "rgba(51, 53, 61, 1)",
    "--sjs2-color-fg-basic-primary": "rgba(255, 255, 255, 0.78)",
    "--sjs2-color-fg-basic-secondary": "rgba(125, 129, 143, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-default-icon": "rgba(125, 129, 143, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-default-icon": "rgba(125, 129, 143, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-default-icon": "rgba(125, 129, 143, 1)",
    "--sjs2-color-project-brand-600": "rgba(58, 202, 211, 1)",
    "--sjs2-color-component-tagbox-item-default-bg": "rgba(58, 202, 211, 1)",
    "--sjs2-color-component-tagbox-item-hovered-bg": "rgba(58, 202, 211, 1)",
    "--sjs2-color-bg-brand-secondary": "rgba(67, 70, 80, 1)",
    "--sjs2-color-bg-brand-primary-dim": "rgba(92, 224, 233, 1)",
    "--sjs2-color-fg-brand-on-primary": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-default-label": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-hovered-label": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-action-hovered-icon": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-action-pressed-icon": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-action-default-icon": "rgba(32, 32, 32, 1)",
    "--sjs2-color-fg-brand-primary-disabled": "rgba(32, 32, 32, 0.25)",
    "--sjs2-color-component-tagbox-item-action-hovered-bg": "rgba(32, 32, 32, 0.25)",
    "--sjs2-base-unit-size": "8px",
    "--sjs2-base-unit-spacing": "8px",
    "--sjs2-base-unit-radius": "4px",
    "--sjs2-border-effect-surface-default": "0px 2px 0px 0px rgba(33, 35, 43, 1)",
    "--sjs2-border-effect-component-panel-default": "0px 2px 0px 0px rgba(33, 35, 43, 1)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-default": "0px 2px 0px 0px rgba(33, 35, 43, 1)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-hovered": "0px 2px 0px 0px rgba(33, 35, 43, 1)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-disabled": "0px 2px 0px 0px rgba(33, 35, 43, 1)",
    "--sjs2-border-effect-component-action-brand-primary-default": "0px 2px 0px 0px rgba(33, 35, 43, 1)",
    "--sjs2-border-effect-component-action-brand-primary-hovered": "0px 2px 0px 0px rgba(33, 35, 43, 1)",
    "--sjs2-border-effect-component-action-brand-primary-disabled": "0px 2px 0px 0px rgba(33, 35, 43, 1)",
    "--sjs2-border-effect-floating-default": "0px 2px 6px 0px rgba(0, 0, 0, 0.2),0px 8px 16px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-formbox-default": "0px -2px 0px 0px rgba(33, 35, 43, 1)",
    "--sjs2-border-effect-component-formbox-hovered": "0px -2px 0px 0px rgba(33, 35, 43, 1)",
    "--sjs2-border-effect-component-checkbox-true-default": "0px -2px 0px 0px rgba(33, 35, 43, 1)",
    "--sjs2-border-effect-component-checkbox-false-default": "0px -2px 0px 0px rgba(33, 35, 43, 1)",
    "--sjs2-border-effect-component-radio-true-default": "0px -2px 0px 0px rgba(33, 35, 43, 1)",
    "--sjs2-border-effect-component-radio-false-default": "0px -2px 0px 0px rgba(33, 35, 43, 1)",
    "--sjs2-color-border-basic-secondary": "rgba(65, 69, 83, 1)",
    "--sjs2-color-component-input-default-line": "rgba(97, 101, 118, 1)",
    "--sjs2-color-border-basic-secondary-overlay": "rgba(255, 255, 255, 0.08)",
    "--sjs2-color-bg-alert-primary": "rgba(254, 76, 108, 1)",
    "--sjs2-color-bg-alert-secondary": "rgba(254, 76, 108, 0.1)",
    "--sjs2-color-fg-alert-on-primary": "rgba(48, 48, 48, 1)",
    "--sjs2-color-bg-positive-primary": "rgba(36, 197, 164, 1)",
    "--sjs2-color-bg-positive-secondary": "rgba(36, 197, 164, 0.1)",
    "--sjs2-color-fg-positive-on-primary": "rgba(48, 48, 48, 1)",
    "--sjs2-color-bg-note-primary": "rgba(91, 151, 242, 1)",
    "--sjs2-color-bg-note-secondary": "rgba(91, 151, 242, 0.1)",
    "--sjs2-color-fg-note-on-primary": "rgba(48, 48, 48, 1)",
    "--sjs2-color-bg-warning-primary": "rgba(255, 152, 20, 1)",
    "--sjs2-color-bg-warning-secondary": "rgba(255, 152, 20, 0.1)",
    "--sjs2-color-fg-warning-on-primary": "rgba(48, 48, 48, 1)",
    "--sjs2-radius-component-panel": "4px",
    "--sjs2-radius-component-formbox": "4px",
    "--sjs2-radius-component-action": "4px"
  }
};

export const SolidLightPanelless = {
  "themeName": "solid",
  "colorPalette": "light",
  "isPanelless": true,
  "cssVariables": {
    "--sjs-general-dim-forecolor": "rgba(0, 0, 0, 0.91)",
    "--sjs-general-dim-forecolor-light": "rgba(0, 0, 0, 0.45)",
    "--sjs-secondary-backcolor": "rgba(255, 152, 20, 1)",
    "--sjs-secondary-backcolor-light": "rgba(255, 152, 20, 0.1)",
    "--sjs-secondary-backcolor-semi-light": "rgba(255, 152, 20, 0.25)",
    "--sjs-secondary-forecolor": "rgba(255, 255, 255, 1)",
    "--sjs-secondary-forecolor-light": "rgba(255, 255, 255, 0.25)",
    "--sjs-shadow-small-reset": "0px 0px 0px 0px rgba(0, 0, 0, 0.2)",
    "--sjs-shadow-inner-reset": "inset 0px 0px 0px 0px rgba(0, 0, 0, 0.1)",
    "--sjs-article-font-xx-large-textDecoration": "none",
    "--sjs-article-font-xx-large-fontWeight": "700",
    "--sjs-article-font-xx-large-fontStyle": "normal",
    "--sjs-article-font-xx-large-fontStretch": "normal",
    "--sjs-article-font-xx-large-letterSpacing": "0",
    "--sjs-article-font-xx-large-lineHeight": "64px",
    "--sjs-article-font-xx-large-paragraphIndent": "0px",
    "--sjs-article-font-xx-large-textCase": "none",
    "--sjs-article-font-x-large-textDecoration": "none",
    "--sjs-article-font-x-large-fontWeight": "700",
    "--sjs-article-font-x-large-fontStyle": "normal",
    "--sjs-article-font-x-large-fontStretch": "normal",
    "--sjs-article-font-x-large-letterSpacing": "0",
    "--sjs-article-font-x-large-lineHeight": "56px",
    "--sjs-article-font-x-large-paragraphIndent": "0px",
    "--sjs-article-font-x-large-textCase": "none",
    "--sjs-article-font-large-textDecoration": "none",
    "--sjs-article-font-large-fontWeight": "700",
    "--sjs-article-font-large-fontStyle": "normal",
    "--sjs-article-font-large-fontStretch": "normal",
    "--sjs-article-font-large-letterSpacing": "0",
    "--sjs-article-font-large-lineHeight": "40px",
    "--sjs-article-font-large-paragraphIndent": "0px",
    "--sjs-article-font-large-textCase": "none",
    "--sjs-article-font-medium-textDecoration": "none",
    "--sjs-article-font-medium-fontWeight": "700",
    "--sjs-article-font-medium-fontStyle": "normal",
    "--sjs-article-font-medium-fontStretch": "normal",
    "--sjs-article-font-medium-letterSpacing": "0",
    "--sjs-article-font-medium-lineHeight": "32px",
    "--sjs-article-font-medium-paragraphIndent": "0px",
    "--sjs-article-font-medium-textCase": "none",
    "--sjs-article-font-default-textDecoration": "none",
    "--sjs-article-font-default-fontWeight": "400",
    "--sjs-article-font-default-fontStyle": "normal",
    "--sjs-article-font-default-fontStretch": "normal",
    "--sjs-article-font-default-letterSpacing": "0",
    "--sjs-article-font-default-lineHeight": "28px",
    "--sjs-article-font-default-paragraphIndent": "0px",
    "--sjs-article-font-default-textCase": "none",
    "--sjs2-color-component-action-brand-tertiary-surface-default-bg": "rgba(245, 245, 245, 1)",
    "--sjs2-color-component-action-brand-tertiary-surface-hovered-bg": "rgba(234, 234, 234, 1)",
    "--sjs2-layout-component-page-content-area-gap-horizontal": "var(--sjs2-spacing-large-horizontal)",
    "--sjs2-layout-component-page-content-area-gap-vertical": "var(--sjs2-spacing-large-vertical)",
    "--sjs2-layout-component-panel-simple-box-gap-vertical": "var(--sjs2-spacing-medium-vertical)",
    "--sjs2-layout-component-panel-simple-content-area-padding-horizontal": "var(--sjs2-spacing-x000)",
    "--sjs2-layout-component-panel-simple-content-area-padding-top": "var(--sjs2-spacing-x000)",
    "--sjs2-layout-component-panel-simple-content-area-padding-bottom": "var(--sjs2-spacing-x000)",
    "--sjs2-layout-component-panel-simple-content-area-gap-horizontal": "var(--sjs2-spacing-x500)",
    "--sjs2-layout-component-panel-simple-nested-content-area-gap-horizontal": "var(--sjs2-spacing-x500)",
    "--sjs2-radius-component-panel-simple": "var(--sjs2-radius-x000)",
    "--sjs2-is-panelless": "true",
    "--sjs2-color-utility-surface-survey": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-panel-simple-default-bg": "transparent",
    "--sjs2-color-component-panel-simple-default-border": "transparent",
    "--sjs2-color-component-panel-default-bg": "transparent",
    "--sjs2-color-bg-basic-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-utility-property-grid": "rgba(255, 255, 255, 1)",
    "--sjs2-color-utility-tabs": "rgba(255, 255, 255, 1)",
    "--sjs2-color-utility-toolbox": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-default-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-hovered-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-default-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-hovered-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-default-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-hovered-bg": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-basic-primary-dim": "rgba(243, 243, 243, 1)",
    "--sjs2-color-bg-neutral-tertiary-dim": "rgba(255, 255, 255, 1)",
    "--sjs2-color-utility-sheet": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-basic-secondary": "rgba(245, 245, 245, 1)",
    "--sjs2-color-bg-basic-secondary-dim": "rgba(234, 234, 234, 1)",
    "--sjs2-color-fg-basic-primary": "rgba(0, 0, 0, 0.91)",
    "--sjs2-color-fg-basic-secondary": "rgba(0, 0, 0, 0.43)",
    "--sjs2-color-component-action-alert-quaternary-surface-default-icon": "rgba(0, 0, 0, 0.43)",
    "--sjs2-color-component-action-brand-quaternary-surface-default-icon": "rgba(0, 0, 0, 0.43)",
    "--sjs2-color-component-action-neutral-quaternary-surface-default-icon": "rgba(0, 0, 0, 0.43)",
    "--sjs2-color-project-brand-600": "rgba(46, 172, 180, 1)",
    "--sjs2-color-component-tagbox-item-default-bg": "rgba(46, 172, 180, 1)",
    "--sjs2-color-component-tagbox-item-hovered-bg": "rgba(46, 172, 180, 1)",
    "--sjs2-color-bg-brand-secondary": "rgba(46, 172, 180, 0.1)",
    "--sjs2-color-bg-brand-primary-dim": "rgba(23, 156, 165, 1)",
    "--sjs2-color-fg-brand-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-default-label": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-hovered-label": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-action-hovered-icon": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-action-pressed-icon": "rgba(255, 255, 255, 1)",
    "--sjs2-color-component-tagbox-item-action-default-icon": "rgba(255, 255, 255, 1)",
    "--sjs2-color-fg-brand-primary-disabled": "rgba(255, 255, 255, 0.25)",
    "--sjs2-color-component-tagbox-item-action-hovered-bg": "rgba(255, 255, 255, 0.25)",
    "--sjs2-base-unit-size": "8px",
    "--sjs2-base-unit-spacing": "8px",
    "--sjs2-base-unit-radius": "4px",
    "--sjs2-border-effect-surface-default": "0px 2px 0px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-panel-default": "0px 2px 0px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-default": "0px 2px 0px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-hovered": "0px 2px 0px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-disabled": "0px 2px 0px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-primary-default": "0px 2px 0px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-primary-hovered": "0px 2px 0px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-action-brand-primary-disabled": "0px 2px 0px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-floating-default": "0px 2px 6px 0px rgba(0, 0, 0, 0.1),0px 8px 16px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-formbox-default": "inset 0px 2px 0px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-formbox-hovered": "inset 0px 2px 0px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-checkbox-true-default": "inset 0px 2px 0px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-checkbox-false-default": "inset 0px 2px 0px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-radio-true-default": "inset 0px 2px 0px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-border-effect-component-radio-false-default": "inset 0px 2px 0px 0px rgba(0, 0, 0, 0.1)",
    "--sjs2-color-border-basic-secondary": "rgba(0, 0, 0, 0.09)",
    "--sjs2-color-component-input-default-line": "rgba(0, 0, 0, 0.16)",
    "--sjs2-color-border-basic-secondary-overlay": "rgba(0, 0, 0, 0.16)",
    "--sjs2-color-bg-alert-primary": "rgba(229, 10, 62, 1)",
    "--sjs2-color-bg-alert-secondary": "rgba(229, 10, 62, 0.1)",
    "--sjs2-color-fg-alert-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-positive-primary": "rgba(25, 179, 148, 1)",
    "--sjs2-color-bg-positive-secondary": "rgba(25, 179, 148, 0.1)",
    "--sjs2-color-fg-positive-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-note-primary": "rgba(67, 127, 217, 1)",
    "--sjs2-color-bg-note-secondary": "rgba(67, 127, 217, 0.1)",
    "--sjs2-color-fg-note-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-color-bg-warning-primary": "rgba(255, 152, 20, 1)",
    "--sjs2-color-bg-warning-secondary": "rgba(255, 152, 20, 0.1)",
    "--sjs2-color-fg-warning-on-primary": "rgba(255, 255, 255, 1)",
    "--sjs2-radius-component-panel": "4px",
    "--sjs2-radius-component-formbox": "4px",
    "--sjs2-radius-component-action": "4px"
  }
};

export const SolidDarkPanelless = {
  "themeName": "solid",
  "colorPalette": "dark",
  "isPanelless": true,
  "cssVariables": {
    "--sjs-general-dim-forecolor": "rgba(255, 255, 255, 0.79)",
    "--sjs-general-dim-forecolor-light": "rgba(125, 130, 148, 1)",
    "--sjs-secondary-backcolor": "rgba(255, 152, 20, 1)",
    "--sjs-secondary-backcolor-light": "rgba(255, 152, 20, 0.1)",
    "--sjs-secondary-backcolor-semi-light": "rgba(255, 152, 20, 0.25)",
    "--sjs-secondary-forecolor": "rgba(48, 48, 48, 1)",
    "--sjs-secondary-forecolor-light": "rgba(48, 48, 48, 0.25)",
    "--sjs-shadow-small-reset": "0px 0px 0px 0px rgba(33, 35, 43, 1)",
    "--sjs-shadow-inner-reset": "0px 0px 0px 0px rgba(33, 35, 43, 1)",
    "--sjs-article-font-xx-large-textDecoration": "none",
    "--sjs-article-font-xx-large-fontWeight": "700",
    "--sjs-article-font-xx-large-fontStyle": "normal",
    "--sjs-article-font-xx-large-fontStretch": "normal",
    "--sjs-article-font-xx-large-letterSpacing": "0",
    "--sjs-article-font-xx-large-lineHeight": "64px",
    "--sjs-article-font-xx-large-paragraphIndent": "0px",
    "--sjs-article-font-xx-large-textCase": "none",
    "--sjs-article-font-x-large-textDecoration": "none",
    "--sjs-article-font-x-large-fontWeight": "700",
    "--sjs-article-font-x-large-fontStyle": "normal",
    "--sjs-article-font-x-large-fontStretch": "normal",
    "--sjs-article-font-x-large-letterSpacing": "0",
    "--sjs-article-font-x-large-lineHeight": "56px",
    "--sjs-article-font-x-large-paragraphIndent": "0px",
    "--sjs-article-font-x-large-textCase": "none",
    "--sjs-article-font-large-textDecoration": "none",
    "--sjs-article-font-large-fontWeight": "700",
    "--sjs-article-font-large-fontStyle": "normal",
    "--sjs-article-font-large-fontStretch": "normal",
    "--sjs-article-font-large-letterSpacing": "0",
    "--sjs-article-font-large-lineHeight": "40px",
    "--sjs-article-font-large-paragraphIndent": "0px",
    "--sjs-article-font-large-textCase": "none",
    "--sjs-article-font-medium-textDecoration": "none",
    "--sjs-article-font-medium-fontWeight": "700",
    "--sjs-article-font-medium-fontStyle": "normal",
    "--sjs-article-font-medium-fontStretch": "normal",
    "--sjs-article-font-medium-letterSpacing": "0",
    "--sjs-article-font-medium-lineHeight": "32px",
    "--sjs-article-font-medium-paragraphIndent": "0px",
    "--sjs-article-font-medium-textCase": "none",
    "--sjs-article-font-default-textDecoration": "none",
    "--sjs-article-font-default-fontWeight": "400",
    "--sjs-article-font-default-fontStyle": "normal",
    "--sjs-article-font-default-fontStretch": "normal",
    "--sjs-article-font-default-letterSpacing": "0",
    "--sjs-article-font-default-lineHeight": "28px",
    "--sjs-article-font-default-paragraphIndent": "0px",
    "--sjs-article-font-default-textCase": "none",
    "--sjs2-color-component-action-brand-tertiary-surface-default-bg": "rgba(46, 48, 55, 1)",
    "--sjs2-color-component-action-brand-tertiary-surface-hovered-bg": "rgba(51, 53, 61, 1)",
    "--sjs2-layout-component-page-content-area-gap-horizontal": "var(--sjs2-spacing-large-horizontal)",
    "--sjs2-layout-component-page-content-area-gap-vertical": "var(--sjs2-spacing-large-vertical)",
    "--sjs2-layout-component-panel-simple-box-gap-vertical": "var(--sjs2-spacing-medium-vertical)",
    "--sjs2-layout-component-panel-simple-content-area-padding-horizontal": "var(--sjs2-spacing-x000)",
    "--sjs2-layout-component-panel-simple-content-area-padding-top": "var(--sjs2-spacing-x000)",
    "--sjs2-layout-component-panel-simple-content-area-padding-bottom": "var(--sjs2-spacing-x000)",
    "--sjs2-layout-component-panel-simple-content-area-gap-horizontal": "var(--sjs2-spacing-x500)",
    "--sjs2-layout-component-panel-simple-nested-content-area-gap-horizontal": "var(--sjs2-spacing-x500)",
    "--sjs2-radius-component-panel-simple": "var(--sjs2-radius-x000)",
    "--sjs2-is-panelless": "true",
    "--sjs2-color-utility-surface-survey": "rgba(53, 55, 63, 1)",
    "--sjs2-color-component-panel-simple-default-bg": "transparent",
    "--sjs2-color-component-panel-simple-default-border": "transparent",
    "--sjs2-color-component-panel-default-bg": "transparent",
    "--sjs2-color-bg-basic-primary": "rgba(53, 55, 63, 1)",
    "--sjs2-color-utility-property-grid": "rgba(53, 55, 63, 1)",
    "--sjs2-color-utility-tabs": "rgba(53, 55, 63, 1)",
    "--sjs2-color-utility-toolbox": "rgba(53, 55, 63, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-default-bg": "rgba(53, 55, 63, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-hovered-bg": "rgba(53, 55, 63, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-default-bg": "rgba(53, 55, 63, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-hovered-bg": "rgba(53, 55, 63, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-default-bg": "rgba(53, 55, 63, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-hovered-bg": "rgba(53, 55, 63, 1)",
    "--sjs2-color-bg-basic-primary-dim": "rgba(60, 63, 74, 1)",
    "--sjs2-color-bg-neutral-tertiary-dim": "rgba(53, 55, 63, 1)",
    "--sjs2-color-utility-sheet": "rgba(53, 55, 63, 1)",
    "--sjs2-color-bg-basic-secondary": "rgba(46, 48, 55, 1)",
    "--sjs2-color-bg-basic-secondary-dim": "rgba(51, 53, 61, 1)",
    "--sjs2-color-fg-basic-primary": "rgba(255, 255, 255, 0.78)",
    "--sjs2-color-fg-basic-secondary": "rgba(125, 129, 143, 1)",
    "--sjs2-color-component-action-alert-quaternary-surface-default-icon": "rgba(125, 129, 143, 1)",
    "--sjs2-color-component-action-brand-quaternary-surface-default-icon": "rgba(125, 129, 143, 1)",
    "--sjs2-color-component-action-neutral-quaternary-surface-default-icon": "rgba(125, 129, 143, 1)",
    "--sjs2-color-project-brand-600": "rgba(58, 202, 211, 1)",
    "--sjs2-color-component-tagbox-item-default-bg": "rgba(58, 202, 211, 1)",
    "--sjs2-color-component-tagbox-item-hovered-bg": "rgba(58, 202, 211, 1)",
    "--sjs2-color-bg-brand-secondary": "rgba(67, 70, 80, 1)",
    "--sjs2-color-bg-brand-primary-dim": "rgba(92, 224, 233, 1)",
    "--sjs2-color-fg-brand-on-primary": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-default-label": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-hovered-label": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-action-hovered-icon": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-action-pressed-icon": "rgba(32, 32, 32, 1)",
    "--sjs2-color-component-tagbox-item-action-default-icon": "rgba(32, 32, 32, 1)",
    "--sjs2-color-fg-brand-primary-disabled": "rgba(32, 32, 32, 0.25)",
    "--sjs2-color-component-tagbox-item-action-hovered-bg": "rgba(32, 32, 32, 0.25)",
    "--sjs2-base-unit-size": "8px",
    "--sjs2-base-unit-spacing": "8px",
    "--sjs2-base-unit-radius": "4px",
    "--sjs2-border-effect-surface-default": "0px 2px 0px 0px rgba(33, 35, 43, 1)",
    "--sjs2-border-effect-component-panel-default": "0px 2px 0px 0px rgba(33, 35, 43, 1)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-default": "0px 2px 0px 0px rgba(33, 35, 43, 1)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-hovered": "0px 2px 0px 0px rgba(33, 35, 43, 1)",
    "--sjs2-border-effect-component-action-brand-tertiary-surface-disabled": "0px 2px 0px 0px rgba(33, 35, 43, 1)",
    "--sjs2-border-effect-component-action-brand-primary-default": "0px 2px 0px 0px rgba(33, 35, 43, 1)",
    "--sjs2-border-effect-component-action-brand-primary-hovered": "0px 2px 0px 0px rgba(33, 35, 43, 1)",
    "--sjs2-border-effect-component-action-brand-primary-disabled": "0px 2px 0px 0px rgba(33, 35, 43, 1)",
    "--sjs2-border-effect-floating-default": "0px 2px 6px 0px rgba(0, 0, 0, 0.2),0px 8px 16px 0px rgba(0, 0, 0, 0.2)",
    "--sjs2-border-effect-component-formbox-default": "0px -2px 0px 0px rgba(33, 35, 43, 1)",
    "--sjs2-border-effect-component-formbox-hovered": "0px -2px 0px 0px rgba(33, 35, 43, 1)",
    "--sjs2-border-effect-component-checkbox-true-default": "0px -2px 0px 0px rgba(33, 35, 43, 1)",
    "--sjs2-border-effect-component-checkbox-false-default": "0px -2px 0px 0px rgba(33, 35, 43, 1)",
    "--sjs2-border-effect-component-radio-true-default": "0px -2px 0px 0px rgba(33, 35, 43, 1)",
    "--sjs2-border-effect-component-radio-false-default": "0px -2px 0px 0px rgba(33, 35, 43, 1)",
    "--sjs2-color-border-basic-secondary": "rgba(65, 69, 83, 1)",
    "--sjs2-color-component-input-default-line": "rgba(97, 101, 118, 1)",
    "--sjs2-color-border-basic-secondary-overlay": "rgba(255, 255, 255, 0.08)",
    "--sjs2-color-bg-alert-primary": "rgba(254, 76, 108, 1)",
    "--sjs2-color-bg-alert-secondary": "rgba(254, 76, 108, 0.1)",
    "--sjs2-color-fg-alert-on-primary": "rgba(48, 48, 48, 1)",
    "--sjs2-color-bg-positive-primary": "rgba(36, 197, 164, 1)",
    "--sjs2-color-bg-positive-secondary": "rgba(36, 197, 164, 0.1)",
    "--sjs2-color-fg-positive-on-primary": "rgba(48, 48, 48, 1)",
    "--sjs2-color-bg-note-primary": "rgba(91, 151, 242, 1)",
    "--sjs2-color-bg-note-secondary": "rgba(91, 151, 242, 0.1)",
    "--sjs2-color-fg-note-on-primary": "rgba(48, 48, 48, 1)",
    "--sjs2-color-bg-warning-primary": "rgba(255, 152, 20, 1)",
    "--sjs2-color-bg-warning-secondary": "rgba(255, 152, 20, 0.1)",
    "--sjs2-color-fg-warning-on-primary": "rgba(48, 48, 48, 1)",
    "--sjs2-radius-component-panel": "4px",
    "--sjs2-radius-component-formbox": "4px",
    "--sjs2-radius-component-action": "4px"
  }
};
